// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ink: #111522;
    --ink-soft: #242b46;
    --muted: #707994;
    --line: rgba(31, 39, 71, 0.12);
    --paper: #f7f8fc;
    --panel: rgba(255, 255, 255, 0.88);
    --navy: #1d285f;
    --navy-deep: #070b1a;
    --blue: #25327a;
    --blue-soft: #e9ecff;
    --champagne: #d8c29a;
    --pearl: #fbf7ef;
    --rose: #a96c73;
    --danger: #ffe9e6;
    --success: #e5f7ef;
    --shadow: 0 24px 70px rgba(17, 21, 34, 0.12);
    --shadow-soft: 0 12px 30px rgba(17, 21, 34, 0.08);
}

* {
    box-sizing: border-box;
}

body {
    margin: 0;
    color: var(--ink);
    background:
        linear-gradient(135deg, rgba(37, 50, 122, 0.08), transparent 32%),
        linear-gradient(315deg, rgba(216, 194, 154, 0.18), transparent 36%),
        var(--paper);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input,
select,
textarea {
    font: inherit;
}

button {
    cursor: pointer;
}

label {
    display: grid;
    gap: 7px;
    color: var(--ink-soft);
    font-size: 12px;
    font-weight: 800;
}

input,
select,
textarea {
    width: 100%;
    min-height: 44px;
    border: 1px solid var(--line);
    border-radius: 12px;
    color: var(--ink);
    background: rgba(255, 255, 255, 0.86);
    padding: 11px 13px;
    outline: 0;
    transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

input:focus,
select:focus,
textarea:focus {
    border-color: rgba(37, 50, 122, 0.55);
    box-shadow: 0 0 0 4px rgba(37, 50, 122, 0.11);
}

input:disabled,
select:disabled {
    color: #9aa2b8;
    background: #f1f3f8;
}

textarea {
    min-height: 92px;
    resize: vertical;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 8px;
    font-size: 14px;
}

th,
td {
    padding: 13px 12px;
    text-align: left;
    vertical-align: top;
}

th {
    color: var(--muted);
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

td {
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.74);
}

td:first-child {
    border-left: 1px solid var(--line);
    border-radius: 12px 0 0 12px;
}

td:last-child {
    border-right: 1px solid var(--line);
    border-radius: 0 12px 12px 0;
}

tr {
    transition: transform 160ms ease, box-shadow 160ms ease;
}

tbody tr:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 24px rgba(17, 21, 34, 0.07);
}

.sale-row {
    cursor: pointer;
}

td small {
    display: block;
    color: var(--muted);
    margin-top: 4px;
}

.loading-screen,
.login-page {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 24px;
}

.login-page {
    position: relative;
    overflow: hidden;
    background:
        linear-gradient(125deg, rgba(7, 11, 26, 0.96), rgba(29, 40, 95, 0.92) 54%, rgba(10, 13, 28, 0.98)),
        url("https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=1800&q=80");
    background-size: cover;
    background-position: center;
}

.login-page::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg, rgba(216, 194, 154, 0.16) 1px, transparent 1px),
        linear-gradient(0deg, rgba(216, 194, 154, 0.09) 1px, transparent 1px);
    background-size: 78px 78px;
    mask-image: linear-gradient(120deg, transparent, #000 38%, transparent 82%);
    animation: gridDrift 16s linear infinite;
}

.login-shell {
    position: relative;
    width: min(1060px, 100%);
    min-height: 620px;
    display: grid;
    grid-template-columns: 1.1fr 430px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 28px;
    background: rgba(8, 12, 28, 0.62);
    box-shadow: 0 38px 100px rgba(0, 0, 0, 0.36);
    backdrop-filter: blur(18px);
    animation: enterUp 520ms ease both;
}

.login-brand {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 28px;
    padding: 42px;
    color: #fff;
}

.login-brand::after {
    content: "";
    position: absolute;
    inset: auto 42px 42px 42px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(216, 194, 154, 0.8), transparent);
}

.login-brand img {
    width: min(420px, 78%);
    height: auto;
    align-self: flex-start;
    border-radius: 18px;
    filter: brightness(1.45) saturate(1.35);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.28);
}

.login-brand-copy {
    max-width: 480px;
}

.login-brand h1 {
    margin: 0;
    font-size: clamp(54px, 7vw, 92px);
    line-height: 0.95;
    letter-spacing: 0;
}

.login-panel {
    display: grid;
    align-content: center;
    gap: 18px;
    padding: 42px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(251, 247, 239, 0.92));
}

.login-panel h2 {
    margin: 0;
    font-size: 32px;
}

.brand-logo {
    width: 168px;
    height: 38px;
    object-fit: contain;
    object-position: left center;
    border-radius: 10px;
    filter: brightness(1.7) saturate(1.35);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
}

.mobile-header {
    display: none;
}

.app-shell {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 270px minmax(0, 1fr);
}

.sidebar {
    position: sticky;
    top: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 22px;
    color: #eef1ff;
    background:
        linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(29, 40, 95, 0.96)),
        var(--navy-deep);
    box-shadow: 18px 0 50px rgba(17, 21, 34, 0.14);
}

.brand-block {
    display: grid;
    gap: 9px;
    padding: 12px 10px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.11);
}

.brand-block span {
    color: rgba(238, 241, 255, 0.7);
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.side-nav {
    display: grid;
    gap: 8px;
}

.side-nav a,
.ghost-button,
.primary-button,
.icon-button {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    border: 0;
    border-radius: 12px;
    text-decoration: none;
    transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease, color 180ms ease;
}

.side-nav a {
    justify-content: flex-start;
    position: relative;
    padding: 12px 13px;
    color: rgba(238, 241, 255, 0.76);
}

.side-nav a svg {
    flex: 0 0 auto;
}

.side-nav a.active,
.side-nav a:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
    transform: translateX(3px);
}

.side-nav a.active::before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 3px;
    border-radius: 999px;
    background: var(--champagne);
}

.logout-button {
    margin-top: auto;
}

.ghost-button {
    padding: 10px 13px;
    color: var(--blue);
    background: var(--blue-soft);
}

.ghost-button.muted {
    color: var(--muted);
    background: rgba(112, 121, 148, 0.12);
}

.ghost-button:hover,
.icon-button:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-soft);
}

.primary-button {
    padding: 11px 18px;
    color: #fff;
    background: linear-gradient(135deg, var(--blue), #111a4d);
    box-shadow: 0 15px 30px rgba(37, 50, 122, 0.24);
}

.primary-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 20px 40px rgba(37, 50, 122, 0.3);
}

.primary-button:disabled {
    opacity: 0.72;
    cursor: wait;
}

.zashani-loader {
    width: 46px;
    height: 46px;
    display: inline-grid;
    place-items: center;
    border-radius: 15px;
    background: linear-gradient(145deg, rgba(7, 11, 26, 0.95), rgba(37, 50, 122, 0.92));
    box-shadow: 0 16px 36px rgba(37, 50, 122, 0.2);
    animation: zPulse 1200ms ease-in-out infinite;
}

.zashani-loader.small {
    width: 22px;
    height: 22px;
    border-radius: 7px;
    box-shadow: none;
}

.zashani-loader svg {
    width: 72%;
    height: 72%;
    fill: none;
    stroke: var(--champagne);
    stroke-width: 11;
    stroke-linecap: square;
    stroke-linejoin: miter;
    stroke-dasharray: 155;
    stroke-dashoffset: 155;
    filter: drop-shadow(0 0 8px rgba(216, 194, 154, 0.34));
    animation: drawZ 1200ms ease-in-out infinite;
}

.zashani-loader.small svg {
    stroke-width: 13;
}

.icon-button {
    width: 44px;
    color: var(--blue);
    background: var(--blue-soft);
}

.icon-button.is-spinning svg {
    animation: spin 720ms linear infinite;
}

.icon-button.danger {
    color: #8d2f35;
    background: #ffe9e6;
}

.main-panel {
    min-width: 0;
    padding: 28px;
}

.topbar {
    position: sticky;
    top: 0;
    z-index: 5;
    margin: -28px -28px 24px;
    padding: 22px 28px;
    background: rgba(247, 248, 252, 0.78);
    border-bottom: 1px solid var(--line);
    backdrop-filter: blur(18px);
}

.topbar,
.section-heading,
.table-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.section-heading,
.table-toolbar {
    margin-bottom: 20px;
}

.section-heading.compact {
    margin-bottom: 4px;
}

.section-heading.compact > strong {
    min-width: 138px;
    padding: 10px 14px;
    border-radius: 999px;
    color: var(--blue);
    text-align: center;
    background: var(--blue-soft);
}

.topbar h1,
.section-heading h2,
.panel h2 {
    margin: 0;
}

.topbar h1 {
    font-size: clamp(24px, 3vw, 34px);
}

.eyebrow {
    margin: 0 0 4px;
    color: var(--champagne);
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.13em;
    text-transform: uppercase;
}

.topbar .eyebrow,
.panel .eyebrow,
.section-heading .eyebrow {
    color: var(--blue);
}

.user-pill {
    display: grid;
    grid-template-columns: 42px auto;
    grid-template-rows: auto auto;
    align-items: center;
    column-gap: 10px;
    color: var(--muted);
    font-size: 13px;
}

.avatar {
    grid-row: 1 / 3;
    width: 42px;
    height: 42px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #fff;
    font-weight: 900;
    background: linear-gradient(135deg, var(--blue), var(--rose));
    box-shadow: var(--shadow-soft);
}

.user-pill strong {
    color: var(--ink);
}

.content-section,
.two-column,
.sales-layout {
    display: grid;
    gap: 22px;
}

.two-column {
    grid-template-columns: minmax(300px, 400px) minmax(0, 1fr);
    align-items: start;
}

.sales-layout {
    grid-template-columns: minmax(420px, 1.08fr) minmax(0, 0.92fr);
    align-items: start;
}

.panel,
.metric-card {
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.76);
    border-radius: 18px;
    background: var(--panel);
    box-shadow: var(--shadow-soft);
    backdrop-filter: blur(16px);
}

.panel::before,
.metric-card::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-radius: inherit;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), transparent 46%);
}

.panel > *,
.metric-card > * {
    position: relative;
}

.panel {
    display: grid;
    gap: 16px;
    padding: 20px;
}

.panel.is-busy {
    overflow: hidden;
}

.form-title-row,
.row-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.form-title-row {
    justify-content: space-between;
}

.row-actions {
    flex-wrap: nowrap;
}

.edit-panel {
    position: relative;
    display: grid;
    gap: 13px;
    padding: 16px;
    border: 1px solid rgba(37, 50, 122, 0.18);
    border-radius: 16px;
    background: rgba(233, 236, 255, 0.42);
}

.edit-panel h3 {
    margin: 0;
}

.edit-panel.is-busy {
    overflow: hidden;
}

.panel-loader {
    position: absolute;
    inset: 0;
    z-index: 4;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 12px;
    color: var(--blue);
    font-size: 13px;
    font-weight: 900;
    background: rgba(247, 248, 252, 0.74);
    backdrop-filter: blur(8px);
}

.sale-form {
    border-color: rgba(37, 50, 122, 0.16);
}

.sale-date-pill {
    width: max-content;
    display: inline-flex;
    align-items: center;
    margin-top: 8px;
    padding: 7px 10px;
    border: 1px solid rgba(37, 50, 122, 0.12);
    border-radius: 999px;
    color: var(--ink-soft);
    background: rgba(233, 236, 255, 0.58);
    font-size: 12px;
    font-weight: 900;
}

.customer-picker {
    grid-column: 1 / -1;
    display: grid;
    gap: 9px;
    padding: 11px;
    border: 1px solid rgba(37, 50, 122, 0.13);
    border-radius: 16px;
    background:
        linear-gradient(135deg, rgba(233, 236, 255, 0.78), rgba(255, 255, 255, 0.72)),
        rgba(247, 248, 252, 0.82);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.customer-picker-header,
.customer-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.customer-picker-header div {
    display: grid;
    gap: 2px;
}

.customer-picker-header span,
.customer-picker-header small,
.customer-pagination span,
.selected-customer span,
.selected-customer small,
.customer-results span,
.customer-results small,
.customer-empty span {
    font-size: 12px;
    font-weight: 800;
}

.customer-picker-header span {
    color: var(--navy);
    font-size: 13px;
    font-weight: 900;
}

.customer-picker-header small,
.customer-pagination span,
.selected-customer small,
.customer-results small,
.customer-empty span {
    color: var(--muted);
}

.customer-picker-header button {
    min-height: 34px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 12px;
    border: 1px solid rgba(37, 50, 122, 0.13);
    border-radius: 999px;
    color: var(--blue);
    background: rgba(255, 255, 255, 0.72);
    font-size: 12px;
    font-weight: 900;
}

.customer-picker-header button.active {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, var(--blue), #111a4d);
}

.search-field {
    position: relative;
}

.search-field svg {
    position: absolute;
    left: 13px;
    bottom: 13px;
    color: var(--muted);
}

.search-field input {
    padding-left: 40px;
}

.selected-customer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 12px;
    padding: 9px 11px;
    border: 1px solid rgba(24, 128, 86, 0.22);
    border-radius: 13px;
    background: rgba(223, 247, 234, 0.72);
}

.selected-customer strong {
    color: #174b37;
}

.selected-customer span {
    color: var(--ink-soft);
}

.customer-picker-collapsed {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 7px 12px;
    min-height: 48px;
    padding: 10px 12px;
    border: 1px dashed rgba(37, 50, 122, 0.2);
    border-radius: 13px;
    background: rgba(255, 255, 255, 0.62);
    animation: fadeIn 180ms ease both;
}

.customer-picker-collapsed > div {
    display: grid;
    gap: 2px;
}

.customer-picker-collapsed strong {
    color: var(--navy);
    font-size: 13px;
}

.customer-picker-collapsed span {
    color: var(--muted);
    font-size: 12px;
    font-weight: 800;
}

.customer-picker-collapsed .ghost-button {
    min-height: 34px;
    padding: 7px 10px;
    border-radius: 999px;
}

.new-customer-fields {
    display: grid;
    gap: 13px;
    padding: 14px;
    border: 1px solid rgba(37, 50, 122, 0.12);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.58);
    animation: enterUp 220ms ease both;
}

.new-customer-fields h3 {
    margin: 0;
    color: var(--navy);
    font-size: 16px;
}

.new-customer-fields .ghost-button {
    min-height: 36px;
}

.customer-results {
    display: grid;
    gap: 6px;
    max-height: 218px;
    overflow: auto;
    padding-right: 3px;
}

.customer-results .table-state {
    min-height: 104px;
}

.customer-results button,
.customer-empty {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(86px, 0.5fr);
    gap: 4px 10px;
    align-items: center;
    width: 100%;
    padding: 8px 10px;
    border: 1px solid rgba(31, 39, 71, 0.09);
    border-radius: 12px;
    text-align: left;
    background: rgba(255, 255, 255, 0.8);
    transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.customer-results button:hover,
.customer-results button.active {
    transform: translateY(-1px);
    border-color: rgba(37, 50, 122, 0.22);
    background: #fff;
    box-shadow: 0 14px 28px rgba(17, 21, 34, 0.08);
}

.customer-results button.active {
    border-color: rgba(24, 128, 86, 0.34);
    box-shadow: 0 16px 30px rgba(24, 128, 86, 0.12);
}

.customer-results strong,
.customer-empty strong {
    min-width: 0;
    overflow: hidden;
    color: var(--navy);
    font-size: 13px;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.customer-results span {
    justify-self: end;
    color: var(--ink-soft);
}

.customer-results small {
    grid-column: 1 / -1;
}

.customer-empty {
    grid-template-columns: 1fr;
    min-height: 74px;
    align-content: center;
}

.customer-pagination {
    padding-top: 2px;
}

.customer-list-controls {
    display: grid;
    padding: 12px;
    border: 1px solid var(--line);
    border-radius: 16px;
    background: rgba(247, 248, 252, 0.72);
}

.metric-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 16px;
}

.metric-card {
    display: grid;
    gap: 8px;
    min-height: 132px;
    padding: 20px;
    overflow: hidden;
    animation: enterUp 520ms ease both;
    animation-delay: var(--delay, 0ms);
}

.metric-card::after {
    content: "";
    position: absolute;
    right: 18px;
    bottom: 16px;
    width: 64px;
    height: 6px;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--champagne), var(--blue));
    opacity: 0.5;
}

.metric-card span {
    color: var(--muted);
    font-size: 13px;
    font-weight: 800;
}

.metric-card strong {
    color: var(--navy);
    font-size: clamp(28px, 4vw, 38px);
    line-height: 1;
}

.metric-skeleton span,
.metric-skeleton strong {
    display: block;
    border-radius: 999px;
    color: transparent;
    background: linear-gradient(90deg, rgba(37, 50, 122, 0.08), rgba(216, 194, 154, 0.2), rgba(37, 50, 122, 0.08));
    background-size: 220% 100%;
    animation: shimmer 1100ms ease-in-out infinite;
}

.metric-skeleton span {
    width: 56%;
    height: 14px;
}

.metric-skeleton strong {
    width: 74%;
    height: 42px;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 13px;
}

.form-grid.three {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.form-grid.four {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.line-items {
    display: grid;
    gap: 10px;
}

.line-item {
    display: grid;
    grid-template-columns: minmax(150px, 1fr) 140px 44px;
    gap: 9px;
    align-items: center;
    padding: 10px;
    border: 1px solid var(--line);
    border-radius: 16px;
    background: rgba(247, 248, 252, 0.78);
}

.product-image-uploader {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr) auto;
    gap: 12px;
    align-items: end;
    padding: 12px;
    border: 1px solid var(--line);
    border-radius: 16px;
    background: rgba(247, 248, 252, 0.76);
}

.product-image-preview,
.product-thumb {
    display: grid;
    place-items: center;
    overflow: hidden;
    border: 1px solid rgba(31, 39, 71, 0.1);
    color: var(--blue);
    background:
        linear-gradient(135deg, rgba(233, 236, 255, 0.82), rgba(251, 247, 239, 0.86));
}

.product-image-preview {
    width: 92px;
    aspect-ratio: 1;
    border-radius: 16px;
    font-size: 28px;
}

.product-thumb {
    width: 52px;
    aspect-ratio: 1;
    border-radius: 12px;
    font-size: 20px;
}

.product-thumb.has-image {
    color: #6f541e;
    background: linear-gradient(135deg, rgba(216, 194, 154, 0.45), rgba(233, 236, 255, 0.78));
}

.image-status {
    width: max-content;
    min-width: 118px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 8px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 900;
    white-space: nowrap;
}

.image-status svg {
    width: 16px;
    height: 16px;
}

.image-status.is-ready {
    color: #176a3a;
    border: 1px solid rgba(23, 106, 58, 0.18);
    background: rgba(222, 247, 232, 0.9);
}

.image-status.is-missing {
    color: #a53636;
    border: 1px solid rgba(165, 54, 54, 0.18);
    background: rgba(255, 232, 232, 0.92);
}

.product-image-preview img,
.product-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.toggle-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.switch-row {
    min-height: 46px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid var(--line);
    border-radius: 14px;
    color: var(--ink-soft);
    background: rgba(247, 248, 252, 0.76);
}

.switch-row.compact {
    min-height: 38px;
    padding: 7px 9px;
}

.switch-row input {
    width: 18px;
    min-height: 18px;
    accent-color: var(--blue);
}

.muted-row {
    opacity: 0.68;
}

.inventory-heading {
    margin-bottom: 0;
}

.inventory-insights {
    display: grid;
    grid-template-columns: repeat(6, minmax(118px, 1fr));
    gap: 10px;
}

.inventory-stat {
    position: relative;
    display: grid;
    gap: 5px;
    min-height: 82px;
    padding: 14px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.76);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.76);
    box-shadow: 0 12px 28px rgba(17, 21, 34, 0.06);
}

.inventory-stat::after {
    content: "";
    position: absolute;
    right: 12px;
    bottom: 12px;
    width: 44px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--champagne), var(--blue));
    opacity: 0.42;
}

.inventory-stat span {
    color: var(--muted);
    font-size: 11px;
    font-weight: 900;
    text-transform: uppercase;
}

.inventory-stat strong {
    color: var(--navy);
    font-size: 28px;
    line-height: 1;
}

.inventory-stat.success strong {
    color: #176a3a;
}

.inventory-stat.danger strong {
    color: #a53636;
}

.inventory-stat.warning strong {
    color: #8a681f;
}

.inventory-page .panel {
    padding: 16px;
}

.inventory-page .table-toolbar {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) auto;
    align-items: start;
    gap: 12px;
}

.inventory-control-bar {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) auto auto;
    gap: 9px;
    align-items: center;
}

.search-control {
    min-height: 44px;
    display: grid;
    grid-template-columns: 20px minmax(0, 1fr);
    gap: 8px;
    align-items: center;
    padding: 0 12px;
    border: 1px solid var(--line);
    border-radius: 13px;
    color: var(--muted);
    background: rgba(247, 248, 252, 0.9);
}

.search-control input {
    min-height: 40px;
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
}

.inventory-filter-chips {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.inventory-filter-chips button {
    min-height: 38px;
    padding: 8px 11px;
    border: 1px solid rgba(31, 39, 71, 0.09);
    border-radius: 999px;
    color: var(--ink-soft);
    font-size: 12px;
    font-weight: 900;
    background: rgba(247, 248, 252, 0.92);
}

.inventory-filter-chips button.active {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, var(--blue), #111a4d);
    box-shadow: 0 12px 24px rgba(37, 50, 122, 0.18);
}

.inventory-filter-chips button.muted {
    color: var(--muted);
    background: rgba(112, 121, 148, 0.12);
}

.inventory-page .table-wrap {
    max-height: calc(100vh - 360px);
    min-height: 430px;
    border-radius: 14px;
}

.inventory-page th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: rgba(247, 248, 252, 0.96);
    backdrop-filter: blur(10px);
}

.inventory-page td {
    padding-top: 10px;
    padding-bottom: 10px;
}

.pagination-bar {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-top: 14px;
    color: var(--muted);
    font-size: 13px;
    font-weight: 900;
}

.catalog-product-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 220px;
}

.icon-button.is-featured {
    color: #6f541e;
    background: rgba(216, 194, 154, 0.32);
}

.public-catalog-page {
    min-height: 100vh;
    padding-top: 24px;
    color: var(--ink);
    background:
        linear-gradient(180deg, rgba(7, 11, 26, 0.98) 0, rgba(17, 26, 77, 0.94) 460px, transparent 461px),
        linear-gradient(135deg, rgba(216, 194, 154, 0.16), transparent 46%),
        var(--paper);
}

.catalog-nav {
    position: sticky;
    top: 16px;
    z-index: 20;
    width: min(1180px, calc(100% - 32px));
    min-height: 82px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 22px;
    margin: 0 auto;
    padding: 14px 18px;
    border: 1px solid rgba(238, 241, 255, 0.14);
    border-radius: 26px;
    overflow: hidden;
    background:
        linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 40%),
        rgba(7, 11, 26, 0.5);
    box-shadow: 0 20px 55px rgba(7, 11, 26, 0.22);
    backdrop-filter: blur(22px);
    animation: catalogDropIn 520ms ease both;
    transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease;
}

.catalog-nav::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(105deg, transparent 0, rgba(255, 255, 255, 0.11) 42%, transparent 68%);
    transform: translateX(-110%);
    animation: catalogShine 4.8s ease-in-out 900ms infinite;
}

.catalog-nav:hover {
    transform: translateY(-1px);
    border-color: rgba(216, 194, 154, 0.32);
    box-shadow: 0 26px 65px rgba(7, 11, 26, 0.28);
}

.catalog-nav-brand {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 18px;
    min-width: 0;
}

.catalog-nav-brand img {
    width: min(176px, 48vw);
    filter:
        brightness(1.28)
        saturate(1.18)
        drop-shadow(0 0 14px rgba(82, 98, 216, 0.46))
        drop-shadow(0 10px 20px rgba(0, 0, 0, 0.22));
    transition: filter 220ms ease, transform 220ms ease;
}

.catalog-nav:hover .catalog-nav-brand img {
    filter:
        brightness(1.48)
        saturate(1.24)
        drop-shadow(0 0 18px rgba(112, 129, 255, 0.58))
        drop-shadow(0 12px 24px rgba(0, 0, 0, 0.24));
    transform: translateY(-1px);
}

.catalog-nav-brand span {
    min-height: 34px;
    display: inline-flex;
    align-items: center;
    padding-left: 18px;
    border-left: 1px solid rgba(238, 241, 255, 0.16);
    color: rgba(238, 241, 255, 0.74);
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.13em;
    text-transform: uppercase;
    white-space: nowrap;
}

.catalog-nav-links {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px;
    border: 1px solid rgba(238, 241, 255, 0.12);
    border-radius: 999px;
    background: rgba(7, 11, 26, 0.46);
    backdrop-filter: blur(18px);
}

.catalog-nav-links a {
    min-height: 36px;
    display: inline-flex;
    align-items: center;
    padding: 0 14px;
    border-radius: 999px;
    color: rgba(238, 241, 255, 0.8);
    text-decoration: none;
    font-size: 13px;
    font-weight: 900;
}

.catalog-nav-links a:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
}

.catalog-hero {
    position: relative;
    isolation: isolate;
    min-height: 660px;
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(340px, 1.1fr);
    gap: clamp(22px, 5vw, 72px);
    align-items: center;
    width: min(1180px, calc(100% - 32px));
    margin: 28px auto 38px;
    padding: clamp(38px, 6vw, 72px);
    overflow: hidden;
    border: 1px solid rgba(238, 241, 255, 0.12);
    border-radius: 34px;
    box-shadow: 0 30px 90px rgba(7, 11, 26, 0.28);
    color: #fff;
    background-image:
        linear-gradient(90deg, rgba(7, 11, 26, 0.98), rgba(7, 11, 26, 0.74) 48%, rgba(7, 11, 26, 0.08)),
        var(--hero-image, linear-gradient(135deg, #070b1a, #25327a));
    background-position: center;
    background-size: cover;
    animation: catalogHeroIn 660ms ease 80ms both;
}

.catalog-hero::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
        linear-gradient(135deg, rgba(216, 194, 154, 0.16), transparent 32%),
        linear-gradient(0deg, rgba(7, 11, 26, 0.28), transparent 34%);
}

.catalog-hero::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(216, 194, 154, 0.68), transparent);
    animation: catalogGlowLine 3.8s ease-in-out infinite;
}

.catalog-hero-copy {
    position: relative;
    z-index: 1;
    display: grid;
    gap: 18px;
    max-width: 620px;
    animation: catalogHeroCopyIn 680ms ease both;
}

.catalog-hero-copy .eyebrow {
    margin: 0;
}

.catalog-hero h1 {
    margin: 0;
    font-size: clamp(54px, 9vw, 118px);
    line-height: 0.86;
    letter-spacing: 0;
    text-wrap: balance;
    text-shadow: 0 22px 44px rgba(0, 0, 0, 0.32);
}

.catalog-hero-copy > p:last-of-type {
    margin: 0;
    max-width: 520px;
    color: rgba(238, 241, 255, 0.82);
    font-size: clamp(17px, 2vw, 21px);
    font-weight: 700;
    line-height: 1.5;
}

.catalog-hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 11px;
    margin-top: 2px;
}

.catalog-hero-actions .primary-button,
.catalog-hero-actions .ghost-button {
    position: relative;
    min-height: 50px;
    overflow: hidden;
    border-radius: 999px;
}

.catalog-hero-actions .primary-button::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.22), transparent);
    transform: translateX(-120%);
    animation: catalogShine 3.9s ease-in-out 1.1s infinite;
}

.catalog-whatsapp {
    color: #fff;
    border: 1px solid rgba(238, 241, 255, 0.16);
    background: rgba(238, 241, 255, 0.12);
    backdrop-filter: blur(14px);
}

.catalog-hero-stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    max-width: 560px;
    margin-top: 4px;
}

.catalog-hero-stats span {
    display: grid;
    gap: 4px;
    min-height: 72px;
    padding: 13px 14px;
    border: 1px solid rgba(238, 241, 255, 0.14);
    border-radius: 18px;
    color: rgba(238, 241, 255, 0.72);
    background: rgba(238, 241, 255, 0.09);
    backdrop-filter: blur(14px);
    font-size: 11px;
    font-weight: 900;
    text-transform: uppercase;
    transition: transform 180ms ease, background 180ms ease, border-color 180ms ease;
}

.catalog-hero-stats span:hover {
    transform: translateY(-2px);
    border-color: rgba(216, 194, 154, 0.28);
    background: rgba(238, 241, 255, 0.13);
}

.catalog-hero-stats strong {
    min-width: 0;
    overflow: hidden;
    color: #fff;
    font-size: clamp(20px, 3vw, 30px);
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.catalog-hero-showcase {
    position: relative;
    z-index: 1;
    min-height: 460px;
}

.hero-product-shot {
    position: absolute;
    overflow: hidden;
    border: 1px solid rgba(238, 241, 255, 0.16);
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
    transform-origin: center;
    animation:
        heroShotIn 680ms ease both,
        heroFloat 6.8s ease-in-out infinite;
    animation-delay: var(--shot-delay, 0ms), calc(760ms + var(--float-delay, 0ms));
    will-change: transform;
}

.hero-product-shot img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.01);
    transition: transform 420ms ease, filter 420ms ease;
}

.hero-product-shot:hover img {
    filter: saturate(1.08) contrast(1.04);
    transform: scale(1.06);
}

.hero-product-shot span {
    position: absolute;
    left: 14px;
    bottom: 14px;
    padding: 7px 11px;
    border-radius: 999px;
    color: #fff;
    background: rgba(7, 11, 26, 0.66);
    backdrop-filter: blur(12px);
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
}

.hero-product-shot.shot-1 {
    inset: 16px 42px 42px 120px;
}

.hero-product-shot.shot-2 {
    left: 12px;
    bottom: 8px;
    width: 210px;
    height: 250px;
    animation-delay: 90ms;
}

.hero-product-shot.shot-3 {
    right: 4px;
    top: 72px;
    width: 178px;
    height: 214px;
    animation-delay: 160ms;
}

.empty-shot {
    inset: 54px 80px;
    display: grid;
    place-items: center;
    color: rgba(238, 241, 255, 0.76);
    font-size: 44px;
}

.catalog-bar,
.catalog-section,
.catalog-notice {
    width: min(1180px, calc(100% - 32px));
    margin: 0 auto 22px;
}

.catalog-bar {
    position: sticky;
    top: 100px;
    z-index: 12;
    display: grid;
    gap: 12px;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.78);
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.84);
    box-shadow: 0 20px 45px rgba(17, 21, 34, 0.1);
    backdrop-filter: blur(18px);
    animation: catalogLiftIn 600ms ease 120ms both;
}

.catalog-filter {
    display: grid;
    grid-template-columns: 180px minmax(220px, 1fr) auto;
    gap: 10px;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
}

.catalog-filter-label {
    display: grid;
    align-content: center;
    padding: 8px 12px;
    border-radius: 14px;
    color: var(--navy);
    background: rgba(233, 236, 255, 0.64);
}

.catalog-filter-label span {
    font-size: 13px;
    font-weight: 900;
}

.catalog-filter-label small {
    color: var(--muted);
    font-size: 11px;
    font-weight: 800;
}

.catalog-filter label {
    position: relative;
}

.catalog-filter label svg {
    position: absolute;
    left: 13px;
    top: 50%;
    z-index: 1;
    transform: translateY(-50%);
    color: var(--muted);
}

.catalog-filter input {
    padding-left: 40px;
    border-radius: 14px;
    background: rgba(247, 248, 252, 0.92);
}

.catalog-category-strip {
    display: flex;
    gap: 9px;
    overflow-x: auto;
    padding: 2px 1px 5px;
    scrollbar-width: thin;
}

.catalog-category-strip button {
    flex: 0 0 auto;
    min-height: 40px;
    padding: 9px 14px;
    border: 1px solid rgba(31, 39, 71, 0.1);
    border-radius: 999px;
    color: var(--ink-soft);
    font-size: 13px;
    font-weight: 900;
    background: rgba(247, 248, 252, 0.92);
}

.catalog-category-strip button.active,
.catalog-category-strip button:hover {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, rgba(37, 50, 122, 0.86), rgba(17, 26, 77, 0.94));
    box-shadow: 0 14px 26px rgba(37, 50, 122, 0.18);
}

.catalog-notice {
    border-radius: 16px;
    padding: 13px 15px;
    color: #174b37;
    background: var(--success);
    font-weight: 800;
}

.catalog-section {
    display: grid;
    gap: 18px;
    padding: 8px 0 34px;
    animation: catalogLiftIn 620ms ease 180ms both;
}

.catalog-section-title h2 {
    margin: 4px 0 0;
    font-size: clamp(24px, 4vw, 38px);
}

.catalog-section-title span {
    display: inline-block;
    margin-top: 5px;
    color: var(--muted);
    font-size: 13px;
    font-weight: 800;
}

.catalog-grid,
.catalog-featured-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));
    gap: 18px;
}

.catalog-featured-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.catalog-card {
    position: relative;
    display: grid;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.78);
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 16px 42px rgba(17, 21, 34, 0.08);
    animation: catalogCardIn 520ms ease var(--card-delay, 0ms) both;
    transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
}

.catalog-card:hover {
    transform: translateY(-4px);
    border-color: rgba(216, 194, 154, 0.42);
    box-shadow: 0 26px 60px rgba(17, 21, 34, 0.14);
}

.catalog-card.featured {
    display: grid;
    grid-template-columns: 42% 1fr;
    min-height: 270px;
}

.catalog-image {
    position: relative;
    min-height: 285px;
    width: 100%;
    display: grid;
    place-items: center;
    overflow: hidden;
    border: 0;
    border-radius: 0;
    color: var(--blue);
    font-size: 34px;
    background:
        linear-gradient(135deg, rgba(233, 236, 255, 0.88), rgba(251, 247, 239, 0.96));
}

button.catalog-image {
    cursor: zoom-in;
}

button.catalog-image:disabled {
    cursor: default;
}

.catalog-card.featured .catalog-image {
    min-height: 100%;
}

.catalog-load-more {
    display: flex;
    justify-content: center;
    padding: 8px 0 20px;
}

.is-spinning {
    animation: spin 900ms linear infinite;
}

.catalog-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 220ms ease;
}

button.catalog-image:hover img {
    transform: scale(1.04);
}

.catalog-zoom-hint {
    position: absolute;
    right: 12px;
    bottom: 12px;
    min-height: 34px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 10px;
    border-radius: 999px;
    color: #fff;
    background: rgba(7, 11, 26, 0.72);
    backdrop-filter: blur(10px);
    font-size: 12px;
    font-weight: 900;
    opacity: 0;
    transform: translateY(6px);
    transition: opacity 180ms ease, transform 180ms ease;
}

button.catalog-image:hover .catalog-zoom-hint,
button.catalog-image:focus-visible .catalog-zoom-hint {
    opacity: 1;
    transform: translateY(0);
}

.catalog-card-body,
.catalog-card.featured > div:last-child {
    display: grid;
    gap: 10px;
    padding: 17px;
}

.catalog-card-topline {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
}

.catalog-card span,
.catalog-card small {
    color: var(--muted);
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
}

.catalog-card-topline small {
    padding: 5px 8px;
    border-radius: 999px;
    color: #6f541e;
    background: rgba(216, 194, 154, 0.24);
}

.catalog-code {
    margin-top: -6px;
}

.catalog-card h3 {
    margin: 0;
    color: var(--navy);
    font-size: 25px;
    line-height: 1;
    display: -webkit-box;
    min-height: 50px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.catalog-card p {
    margin: 0;
    color: var(--ink-soft);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.45;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.catalog-card strong {
    color: var(--ink);
    font-size: 20px;
}

.catalog-card-footer {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
}

.catalog-action {
    min-height: 46px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 2px;
    border-radius: 14px;
    color: #fff;
    background: linear-gradient(135deg, var(--blue), #111a4d);
    text-decoration: none;
    font-weight: 900;
    box-shadow: 0 14px 28px rgba(37, 50, 122, 0.2);
    transition: transform 180ms ease, box-shadow 180ms ease;
}

.catalog-action:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 34px rgba(37, 50, 122, 0.26);
}

.catalog-lightbox-backdrop {
    position: fixed;
    inset: 0;
    z-index: 100;
    display: grid;
    place-items: center;
    padding: 22px;
    background: rgba(7, 11, 26, 0.78);
    backdrop-filter: blur(9px);
    animation: fadeIn 180ms ease both;
}

.catalog-lightbox {
    position: relative;
    width: min(1120px, 100%);
    max-height: 90vh;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 26px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.35);
}

.catalog-lightbox-image {
    min-height: min(76vh, 740px);
    display: grid;
    place-items: center;
    background:
        radial-gradient(circle at 20% 20%, rgba(216, 194, 154, 0.22), transparent 32%),
        #070b1a;
}

.catalog-lightbox-image img {
    width: 100%;
    height: 100%;
    max-height: 86vh;
    object-fit: contain;
}

.catalog-lightbox-info {
    display: grid;
    align-content: center;
    gap: 14px;
    padding: 34px;
    background:
        linear-gradient(135deg, rgba(233, 236, 255, 0.58), transparent 44%),
        rgba(255, 255, 255, 0.96);
}

.catalog-lightbox-info span,
.catalog-lightbox-info small {
    color: var(--muted);
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
}

.catalog-lightbox-info h2 {
    margin: 0;
    color: var(--navy);
    font-size: 38px;
    line-height: 0.96;
}

.catalog-lightbox-info p {
    margin: 0;
    color: var(--ink-soft);
    font-size: 15px;
    font-weight: 700;
    line-height: 1.5;
}

.catalog-lightbox-info strong {
    color: var(--ink);
    font-size: 30px;
}

.table-wrap {
    overflow: auto;
}

.sale-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 80;
    display: grid;
    place-items: center;
    padding: 22px;
    background: rgba(17, 21, 34, 0.54);
    backdrop-filter: blur(7px);
    animation: fadeIn 180ms ease both;
}

.sale-breakdown {
    position: relative;
    display: grid;
    gap: 16px;
    padding: 18px;
    border: 1px solid rgba(37, 50, 122, 0.12);
    border-radius: 18px;
    background:
        linear-gradient(135deg, rgba(37, 50, 122, 0.08), transparent 38%),
        linear-gradient(315deg, rgba(216, 194, 154, 0.2), transparent 40%),
        rgba(255, 255, 255, 0.96);
    box-shadow: 0 18px 40px rgba(17, 21, 34, 0.08);
    animation: enterUp 220ms ease both;
}

.sale-modal {
    width: min(980px, 100%);
    max-height: min(86vh, 820px);
    overflow: auto;
}

.product-edit-modal {
    position: relative;
    width: min(760px, 100%);
}

.product-edit-form {
    padding-top: 28px;
}

.product-edit-form .form-title-row {
    padding-right: 54px;
}

.modal-close-button {
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 2;
    width: 40px;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(31, 39, 71, 0.1);
    border-radius: 13px;
    color: var(--navy);
    background: rgba(255, 255, 255, 0.72);
    box-shadow: 0 10px 24px rgba(17, 21, 34, 0.1);
}

.breakdown-header,
.breakdown-title-row {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    align-items: flex-start;
}

.breakdown-header h3,
.breakdown-section h4 {
    margin: 0;
}

.breakdown-header h3 {
    font-size: 20px;
    line-height: 1.15;
}

.breakdown-header span,
.breakdown-title-row span {
    color: var(--muted);
    font-size: 13px;
    font-weight: 800;
}

.breakdown-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
}

.breakdown-pills span {
    padding: 8px 10px;
    border: 1px solid rgba(37, 50, 122, 0.12);
    border-radius: 999px;
    color: var(--blue);
    background: rgba(233, 236, 255, 0.82);
}

.breakdown-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    gap: 12px;
}

.breakdown-section {
    padding: 14px;
    border: 1px solid rgba(31, 39, 71, 0.1);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.72);
}

.breakdown-section.wide {
    display: grid;
    gap: 12px;
}

.breakdown-section h4 {
    color: var(--navy);
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.breakdown-list {
    display: grid;
    gap: 10px;
    margin: 12px 0 0;
}

.breakdown-list div {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    border-bottom: 1px solid rgba(31, 39, 71, 0.08);
    padding-bottom: 8px;
}

.breakdown-list div:last-child {
    border-bottom: 0;
    padding-bottom: 0;
}

.breakdown-list dt {
    color: var(--muted);
    font-size: 12px;
    font-weight: 800;
}

.breakdown-list dd {
    margin: 0;
    color: var(--ink);
    font-size: 13px;
    font-weight: 800;
    text-align: right;
}

.items-breakdown {
    display: grid;
    gap: 8px;
}

.item-breakdown {
    display: grid;
    grid-template-columns: 1fr repeat(3, minmax(92px, auto));
    gap: 10px;
    align-items: center;
    padding: 10px 12px;
    border: 1px solid rgba(31, 39, 71, 0.09);
    border-radius: 13px;
    background: rgba(247, 248, 252, 0.74);
}

.item-breakdown strong {
    color: var(--blue);
    letter-spacing: 0.04em;
}

.item-breakdown span {
    color: var(--ink-soft);
    font-size: 13px;
    font-weight: 800;
}

.breakdown-total-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 10px;
}

.breakdown-total-grid div {
    display: grid;
    gap: 5px;
    padding: 13px;
    border-radius: 15px;
    color: var(--navy);
    background: linear-gradient(135deg, rgba(233, 236, 255, 0.86), rgba(251, 247, 239, 0.92));
}

.breakdown-total-grid span {
    color: var(--muted);
    font-size: 12px;
    font-weight: 800;
}

.breakdown-total-grid strong {
    font-size: 17px;
}

.breakdown-notes {
    margin: 0;
    color: var(--ink-soft);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
}

.table-subtitle {
    display: inline-block;
    margin-top: 4px;
    color: var(--muted);
    font-size: 13px;
    font-weight: 800;
}

.filter-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    align-items: end;
    padding: 12px;
    border: 1px solid var(--line);
    border-radius: 16px;
    background: rgba(247, 248, 252, 0.72);
}

.filter-panel .search-field {
    min-width: min(260px, 100%);
}

.report-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
}

.report-filter {
    align-self: start;
}

.location-report-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.table-state {
    min-height: 180px;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 10px;
    border: 1px dashed rgba(37, 50, 122, 0.2);
    border-radius: 16px;
    color: var(--muted);
    font-size: 14px;
    font-weight: 800;
    background:
        linear-gradient(135deg, rgba(255, 255, 255, 0.72), rgba(233, 236, 255, 0.58));
}

.table-state.is-loading {
    color: var(--blue);
}

.alert,
.notice {
    border-radius: 14px;
    padding: 11px 13px;
    font-size: 14px;
    font-weight: 700;
}

.alert {
    color: #6d2420;
    background: var(--danger);
}

.notice {
    color: #174b37;
    background: var(--success);
}

.danger-row td {
    background: #fff1ed;
}

@keyframes enterUp {
    from {
        opacity: 0;
        transform: translateY(14px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes gridDrift {
    from {
        transform: translate3d(0, 0, 0);
    }
    to {
        transform: translate3d(78px, 78px, 0);
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes drawZ {
    0% {
        stroke-dashoffset: 155;
        opacity: 0.62;
    }
    45%,
    70% {
        stroke-dashoffset: 0;
        opacity: 1;
    }
    100% {
        stroke-dashoffset: -155;
        opacity: 0.7;
    }
}

@keyframes zPulse {
    0%,
    100% {
        transform: scale(0.96);
    }
    50% {
        transform: scale(1.04);
    }
}

@keyframes shimmer {
    0% {
        background-position: 180% 0;
    }
    100% {
        background-position: -40% 0;
    }
}

@keyframes slideMenu {
    from {
        opacity: 0;
        transform: translateX(-22px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes catalogDropIn {
    from {
        opacity: 0;
        transform: translateY(-14px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes catalogHeroIn {
    from {
        opacity: 0;
        transform: translateY(18px) scale(0.99);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes catalogHeroCopyIn {
    from {
        opacity: 0;
        transform: translateY(18px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes catalogShine {
    0%,
    46% {
        transform: translateX(-120%);
    }
    72%,
    100% {
        transform: translateX(120%);
    }
}

@keyframes catalogGlowLine {
    0%,
    100% {
        opacity: 0.44;
        transform: scaleX(0.68);
    }
    50% {
        opacity: 1;
        transform: scaleX(1);
    }
}

@keyframes catalogLiftIn {
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes catalogCardIn {
    from {
        opacity: 0;
        transform: translateY(18px) scale(0.98);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes heroShotIn {
    from {
        opacity: 0;
        transform: translateY(22px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes heroFloat {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-12px);
    }
}

@media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        scroll-behavior: auto !important;
        transition-duration: 0.01ms !important;
    }
}

@media (max-width: 1080px) {
    .app-shell,
    .two-column,
    .sales-layout {
        grid-template-columns: 1fr;
    }

    .catalog-hero {
        grid-template-columns: 1fr;
        min-height: auto;
        gap: 34px;
        padding: 52px 30px 44px;
    }

    .catalog-hero-showcase {
        min-height: 360px;
    }

    .hero-product-shot.shot-1 {
        inset: 0 80px 28px 80px;
    }

    .hero-product-shot.shot-2 {
        left: 0;
        bottom: 0;
        width: 190px;
        height: 220px;
    }

    .hero-product-shot.shot-3 {
        right: 0;
        top: 52px;
        width: 160px;
        height: 190px;
    }

    .catalog-bar {
        position: static;
        top: auto;
    }

    .inventory-insights {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .inventory-page .table-toolbar {
        grid-template-columns: 1fr;
    }

    .inventory-filter-chips {
        justify-content: flex-start;
    }

    .sidebar {
        position: static;
        height: auto;
        padding: 18px 20px;
    }

    .side-nav {
        grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
    }

    .logout-button {
        margin-top: 0;
    }

    .topbar {
        position: static;
        margin: 0 0 20px;
        border: 1px solid var(--line);
        border-radius: 18px;
    }
}

@media (max-width: 860px) {
    .login-shell {
        min-height: auto;
        grid-template-columns: 1fr;
    }

    .login-brand {
        min-height: 270px;
    }

    .login-brand img {
        width: min(330px, 100%);
    }
}

@media (max-width: 720px) {
    .main-panel,
    .login-panel,
    .login-brand {
        padding: 16px;
    }

    .sidebar {
        position: sticky;
        top: 0;
        z-index: 20;
        gap: 14px;
        padding: 12px 14px 14px;
        border-radius: 0 0 22px 22px;
    }

    .mobile-header {
        display: grid;
        grid-template-columns: 46px minmax(0, 1fr) auto;
        align-items: center;
        gap: 10px;
    }

    .mobile-brand {
        display: grid;
        gap: 6px;
        min-width: 0;
    }

    .mobile-brand span {
        color: rgba(238, 241, 255, 0.72);
        font-size: 11px;
        font-weight: 900;
        letter-spacing: 0.15em;
        text-transform: uppercase;
    }

    .mobile-icon-button,
    .mobile-logout-button {
        min-height: 42px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: 0;
        border-radius: 13px;
        color: #eef1ff;
        backdrop-filter: blur(10px);
    }

    .mobile-icon-button {
        width: 46px;
        background: transparent;
        font-size: 22px;
    }

    .mobile-icon-button:hover {
        background: rgba(255, 255, 255, 0.08);
    }

    .mobile-logout-button {
        justify-self: end;
        width: 42px;
        padding: 0;
        background: transparent;
        font-size: 22px;
    }

    .brand-block {
        display: none;
    }

    .side-nav,
    .logout-button {
        display: none;
    }

    .sidebar.is-open .side-nav {
        position: fixed;
        top: 88px;
        left: 0;
        z-index: 30;
        width: min(78vw, 310px);
        max-height: calc(100vh - 104px);
        display: grid;
        grid-template-columns: 1fr;
        gap: 8px;
        overflow: auto;
        padding: 14px;
        border-radius: 0 22px 22px 0;
        background:
            linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(29, 40, 95, 0.96)),
            var(--navy-deep);
        box-shadow: 22px 24px 50px rgba(7, 11, 26, 0.34);
        animation: slideMenu 240ms ease both;
    }

    .sidebar.is-open .side-nav a {
        min-height: 52px;
        padding: 12px 14px;
        border: 1px solid rgba(255, 255, 255, 0.08);
        background: rgba(255, 255, 255, 0.07);
    }

    .topbar,
    .section-heading,
    .table-toolbar {
        align-items: flex-start;
        flex-direction: column;
    }

    .report-actions {
        width: 100%;
        justify-content: stretch;
    }

    .report-actions .primary-button,
    .report-actions .ghost-button {
        flex: 1 1;
    }

    .user-pill {
        justify-items: start;
    }

    .form-grid,
    .form-grid.three,
    .form-grid.four,
    .line-item,
    .product-image-uploader,
    .toggle-grid,
    .catalog-filter,
    .filter-panel,
    .location-report-grid {
        grid-template-columns: 1fr;
    }

    .pagination-bar {
        align-items: stretch;
        flex-direction: column;
    }

    .inventory-insights {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .inventory-control-bar {
        grid-template-columns: 1fr;
    }

    .inventory-page .table-wrap {
        max-height: none;
        min-height: 320px;
    }

    .catalog-nav {
        top: 8px;
        width: min(100% - 24px, 1180px);
        min-height: 68px;
        padding: 12px 15px;
        border-radius: 20px;
    }

    .catalog-nav-brand {
        gap: 12px;
    }

    .catalog-nav-brand img {
        width: min(152px, 48vw);
    }

    .catalog-nav-brand span {
        display: none;
    }

    .catalog-nav-links {
        display: none;
    }

    .catalog-hero {
        width: min(100% - 24px, 1180px);
        margin-top: 20px;
        margin-bottom: 28px;
        padding: 38px 20px 30px;
        border-radius: 26px;
        background-image:
            linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(7, 11, 26, 0.76) 62%, rgba(7, 11, 26, 0.18)),
            var(--hero-image, linear-gradient(135deg, #070b1a, #25327a));
    }

    .catalog-hero-copy {
        gap: 16px;
    }

    .catalog-hero h1 {
        font-size: clamp(46px, 17vw, 72px);
    }

    .catalog-hero-copy > p:last-of-type {
        font-size: 16px;
    }

    .catalog-hero-actions {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .catalog-hero-stats {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
        margin-top: 2px;
    }

    .catalog-hero-stats span {
        min-height: 64px;
        padding: 10px 8px;
        border-radius: 16px;
        font-size: 9px;
        text-align: center;
        align-content: center;
    }

    .catalog-hero-stats strong {
        font-size: clamp(17px, 5vw, 23px);
    }

    .catalog-hero-showcase {
        min-height: 280px;
    }

    .hero-product-shot.shot-1 {
        inset: 0 38px 28px 38px;
    }

    .hero-product-shot.shot-2 {
        width: 128px;
        height: 156px;
    }

    .hero-product-shot.shot-3 {
        top: 34px;
        width: 118px;
        height: 148px;
    }

    .catalog-filter {
        grid-template-columns: 1fr;
    }

    .catalog-filter .primary-button {
        width: 100%;
    }

    .catalog-card.featured {
        grid-template-columns: 1fr;
    }

    .catalog-image,
    .catalog-card.featured .catalog-image {
        min-height: 240px;
    }

    .catalog-zoom-hint {
        opacity: 1;
        transform: none;
    }

    .catalog-lightbox-backdrop {
        align-items: end;
        padding: 12px;
    }

    .catalog-lightbox {
        max-height: 92vh;
        grid-template-columns: 1fr;
        overflow: auto;
    }

    .catalog-lightbox-image {
        min-height: 52vh;
    }

    .catalog-lightbox-info {
        padding: 18px;
    }

    .sale-modal-backdrop {
        align-items: end;
        padding: 12px;
    }

    .sale-breakdown {
        padding: 14px;
        border-radius: 15px;
    }

    .sale-modal {
        max-height: 88vh;
        width: 100%;
    }

    .breakdown-header,
    .breakdown-title-row {
        display: grid;
        gap: 10px;
    }

    .breakdown-pills {
        justify-content: flex-start;
    }

    .breakdown-grid {
        grid-template-columns: 1fr;
    }

    .breakdown-list div,
    .item-breakdown,
    .customer-results button {
        grid-template-columns: 1fr;
    }

    .customer-results span {
        justify-self: start;
    }

    .customer-picker-header,
    .customer-pagination,
    .customer-picker-collapsed {
        align-items: stretch;
    }

    .customer-picker-collapsed .ghost-button {
        width: 100%;
    }

    .breakdown-list div {
        display: grid;
        gap: 4px;
    }

    .breakdown-list dd {
        text-align: left;
    }

    .line-item .icon-button {
        width: 100%;
    }

    .brand-logo {
        width: 148px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;IAC5C,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB;;;oBAGgB;IAChB,uGAAuG;AAC3G;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;IACV,gFAAgF;AACpF;;AAEA;;;IAGI,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;;IAEI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;;4GAEwG;IACxG,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;6EAEyE;IACzE,0BAA0B;IAC1B,2EAA2E;IAC3E,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,iCAAiC;IACjC,4CAA4C;IAC5C,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,sFAAsF;AAC1F;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb;qFACiF;AACrF;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,cAAc;IACd;;wBAEoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;;;IAII,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,qBAAqB;IACrB,gGAAgG;AACpG;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;;IAEI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yDAAyD;IACzD,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,mFAAmF;IACnF,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,sDAAsD;IACtD,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,qCAAqC;IACrC,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,6DAA6D;IAC7D,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,0DAA0D;IAC1D,kBAAkB;AACtB;;AAEA;IACI,8DAA8D;IAC9D,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;IACpB,sBAAsB;IACtB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB;;iCAE6B;IAC7B,mDAAmD;AACvD;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;;;;;;;IAQI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;;;IAKI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;IACpB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,yCAAyC;IACzC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,2DAA2D;IAC3D,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,uGAAuG;AAC3G;;AAEA;;IAEI,2BAA2B;IAC3B,qCAAqC;IACrC,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,iEAAiE;IACjE,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,8GAA8G;IAC9G,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB;qFACiF;AACrF;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yFAAyF;AAC7F;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,iEAAiE;IACjE,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mDAAmD;IACnD,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yDAAyD;IACzD,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB;;;oBAGgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB;;4BAEwB;IACxB,6CAA6C;IAC7C,2BAA2B;IAC3B,wCAAwC;IACxC,gFAAgF;AACpF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,kGAAkG;IAClG,4BAA4B;IAC5B,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB;;;;oDAIgD;IAChD,mDAAmD;AACvD;;AAEA;IACI;;;;oDAIgD;IAChD,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;IAChD,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,4DAA4D;IAC5D,2BAA2B;IAC3B,mBAAmB;IACnB,qCAAqC;IACrC,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,6CAA6C;IAC7C,WAAW;IACX;;oEAEgE;IAChE,2BAA2B;IAC3B,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB;;qEAEiE;AACrE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,uFAAuF;IACvF,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gCAAgC;IAChC,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,wFAAwF;IACxF,4BAA4B;IAC5B,sDAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,gCAAgC;IAChC,qCAAqC;IACrC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,iCAAiC;IACjC,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,oCAAoC;IACpC,2CAA2C;IAC3C,wBAAwB;IACxB;;2CAEuC;IACvC,8EAA8E;IAC9E,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;;IAGI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,aAAa;IACb,SAAS;IACT,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,6CAA6C;IAC7C,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,oFAAoF;IACpF,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,8CAA8C;IAC9C,+DAA+D;IAC/D,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;qFACiF;AACrF;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,0BAA0B;IAC1B,oDAAoD;AACxD;;AAEA;;IAEI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,yDAAyD;IACzD,qBAAqB;IACrB,gBAAgB;IAChB,8CAA8C;IAC9C,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,2CAA2C;IAC3C,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB;;eAEW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb;;iCAE6B;AACjC;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB;;;iCAG6B;IAC7B,8CAA8C;IAC9C,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;IACpB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yFAAyF;AAC7F;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;qFACiF;AACrF;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;IACA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;IACA;;QAEI,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;QAEI,4BAA4B;IAChC;IACA;;QAEI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;;QAEI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;;;QAGI,qCAAqC;QACrC,uCAAuC;QACvC,gCAAgC;QAChC,sCAAsC;IAC1C;AACJ;;AAEA;IACI;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,OAAO;QACP,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,gDAAgD;IACpD;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,6BAA6B;QAC7B,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;;;QAGI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,WAAW;QACX,SAAS;QACT,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,+CAA+C;QAC/C,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,gCAAgC;QAChC,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;QAChB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,SAAS;QACT,mBAAmB;QACnB,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,UAAU;QACV,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,WAAW;QACX,uBAAuB;QACvB,+BAA+B;QAC/B,aAAa;QACb,0BAA0B;QAC1B,QAAQ;QACR,cAAc;QACd,aAAa;QACb,4BAA4B;QAC5B;;4BAEoB;QACpB,gDAAgD;QAChD,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,2CAA2C;QAC3C,qCAAqC;IACzC;;IAEA;;;QAGI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,wBAAwB;IAC5B;;IAEA;;QAEI,SAAO;IACX;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;;;;;;;;QASI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,gDAAgD;IACpD;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,+BAA+B;QAC/B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB;;wEAEgE;IACpE;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,gDAAgD;QAChD,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;QAC1B,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[":root {\n    --ink: #111522;\n    --ink-soft: #242b46;\n    --muted: #707994;\n    --line: rgba(31, 39, 71, 0.12);\n    --paper: #f7f8fc;\n    --panel: rgba(255, 255, 255, 0.88);\n    --navy: #1d285f;\n    --navy-deep: #070b1a;\n    --blue: #25327a;\n    --blue-soft: #e9ecff;\n    --champagne: #d8c29a;\n    --pearl: #fbf7ef;\n    --rose: #a96c73;\n    --danger: #ffe9e6;\n    --success: #e5f7ef;\n    --shadow: 0 24px 70px rgba(17, 21, 34, 0.12);\n    --shadow-soft: 0 12px 30px rgba(17, 21, 34, 0.08);\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    color: var(--ink);\n    background:\n        linear-gradient(135deg, rgba(37, 50, 122, 0.08), transparent 32%),\n        linear-gradient(315deg, rgba(216, 194, 154, 0.18), transparent 36%),\n        var(--paper);\n    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n    font: inherit;\n}\n\nbutton {\n    cursor: pointer;\n}\n\nlabel {\n    display: grid;\n    gap: 7px;\n    color: var(--ink-soft);\n    font-size: 12px;\n    font-weight: 800;\n}\n\ninput,\nselect,\ntextarea {\n    width: 100%;\n    min-height: 44px;\n    border: 1px solid var(--line);\n    border-radius: 12px;\n    color: var(--ink);\n    background: rgba(255, 255, 255, 0.86);\n    padding: 11px 13px;\n    outline: 0;\n    transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n    border-color: rgba(37, 50, 122, 0.55);\n    box-shadow: 0 0 0 4px rgba(37, 50, 122, 0.11);\n}\n\ninput:disabled,\nselect:disabled {\n    color: #9aa2b8;\n    background: #f1f3f8;\n}\n\ntextarea {\n    min-height: 92px;\n    resize: vertical;\n}\n\ntable {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 8px;\n    font-size: 14px;\n}\n\nth,\ntd {\n    padding: 13px 12px;\n    text-align: left;\n    vertical-align: top;\n}\n\nth {\n    color: var(--muted);\n    font-size: 11px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\ntd {\n    border-top: 1px solid var(--line);\n    border-bottom: 1px solid var(--line);\n    background: rgba(255, 255, 255, 0.74);\n}\n\ntd:first-child {\n    border-left: 1px solid var(--line);\n    border-radius: 12px 0 0 12px;\n}\n\ntd:last-child {\n    border-right: 1px solid var(--line);\n    border-radius: 0 12px 12px 0;\n}\n\ntr {\n    transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\ntbody tr:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 12px 24px rgba(17, 21, 34, 0.07);\n}\n\n.sale-row {\n    cursor: pointer;\n}\n\ntd small {\n    display: block;\n    color: var(--muted);\n    margin-top: 4px;\n}\n\n.loading-screen,\n.login-page {\n    min-height: 100vh;\n    display: grid;\n    place-items: center;\n    padding: 24px;\n}\n\n.login-page {\n    position: relative;\n    overflow: hidden;\n    background:\n        linear-gradient(125deg, rgba(7, 11, 26, 0.96), rgba(29, 40, 95, 0.92) 54%, rgba(10, 13, 28, 0.98)),\n        url(\"https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=1800&q=80\");\n    background-size: cover;\n    background-position: center;\n}\n\n.login-page::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background:\n        linear-gradient(90deg, rgba(216, 194, 154, 0.16) 1px, transparent 1px),\n        linear-gradient(0deg, rgba(216, 194, 154, 0.09) 1px, transparent 1px);\n    background-size: 78px 78px;\n    mask-image: linear-gradient(120deg, transparent, #000 38%, transparent 82%);\n    animation: gridDrift 16s linear infinite;\n}\n\n.login-shell {\n    position: relative;\n    width: min(1060px, 100%);\n    min-height: 620px;\n    display: grid;\n    grid-template-columns: 1.1fr 430px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    border-radius: 28px;\n    background: rgba(8, 12, 28, 0.62);\n    box-shadow: 0 38px 100px rgba(0, 0, 0, 0.36);\n    backdrop-filter: blur(18px);\n    animation: enterUp 520ms ease both;\n}\n\n.login-brand {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 28px;\n    padding: 42px;\n    color: #fff;\n}\n\n.login-brand::after {\n    content: \"\";\n    position: absolute;\n    inset: auto 42px 42px 42px;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, rgba(216, 194, 154, 0.8), transparent);\n}\n\n.login-brand img {\n    width: min(420px, 78%);\n    height: auto;\n    align-self: flex-start;\n    border-radius: 18px;\n    filter: brightness(1.45) saturate(1.35);\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.28);\n}\n\n.login-brand-copy {\n    max-width: 480px;\n}\n\n.login-brand h1 {\n    margin: 0;\n    font-size: clamp(54px, 7vw, 92px);\n    line-height: 0.95;\n    letter-spacing: 0;\n}\n\n.login-panel {\n    display: grid;\n    align-content: center;\n    gap: 18px;\n    padding: 42px;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(251, 247, 239, 0.92));\n}\n\n.login-panel h2 {\n    margin: 0;\n    font-size: 32px;\n}\n\n.brand-logo {\n    width: 168px;\n    height: 38px;\n    object-fit: contain;\n    object-position: left center;\n    border-radius: 10px;\n    filter: brightness(1.7) saturate(1.35);\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);\n}\n\n.mobile-header {\n    display: none;\n}\n\n.app-shell {\n    min-height: 100vh;\n    display: grid;\n    grid-template-columns: 270px minmax(0, 1fr);\n}\n\n.sidebar {\n    position: sticky;\n    top: 0;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 22px;\n    color: #eef1ff;\n    background:\n        linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(29, 40, 95, 0.96)),\n        var(--navy-deep);\n    box-shadow: 18px 0 50px rgba(17, 21, 34, 0.14);\n}\n\n.brand-block {\n    display: grid;\n    gap: 9px;\n    padding: 12px 10px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.11);\n}\n\n.brand-block span {\n    color: rgba(238, 241, 255, 0.7);\n    font-size: 12px;\n    font-weight: 800;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n}\n\n.side-nav {\n    display: grid;\n    gap: 8px;\n}\n\n.side-nav a,\n.ghost-button,\n.primary-button,\n.icon-button {\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 9px;\n    border: 0;\n    border-radius: 12px;\n    text-decoration: none;\n    transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease, color 180ms ease;\n}\n\n.side-nav a {\n    justify-content: flex-start;\n    position: relative;\n    padding: 12px 13px;\n    color: rgba(238, 241, 255, 0.76);\n}\n\n.side-nav a svg {\n    flex: 0 0 auto;\n}\n\n.side-nav a.active,\n.side-nav a:hover {\n    color: #fff;\n    background: rgba(255, 255, 255, 0.1);\n    transform: translateX(3px);\n}\n\n.side-nav a.active::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 10px;\n    bottom: 10px;\n    width: 3px;\n    border-radius: 999px;\n    background: var(--champagne);\n}\n\n.logout-button {\n    margin-top: auto;\n}\n\n.ghost-button {\n    padding: 10px 13px;\n    color: var(--blue);\n    background: var(--blue-soft);\n}\n\n.ghost-button.muted {\n    color: var(--muted);\n    background: rgba(112, 121, 148, 0.12);\n}\n\n.ghost-button:hover,\n.icon-button:hover {\n    transform: translateY(-1px);\n    box-shadow: var(--shadow-soft);\n}\n\n.primary-button {\n    padding: 11px 18px;\n    color: #fff;\n    background: linear-gradient(135deg, var(--blue), #111a4d);\n    box-shadow: 0 15px 30px rgba(37, 50, 122, 0.24);\n}\n\n.primary-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 20px 40px rgba(37, 50, 122, 0.3);\n}\n\n.primary-button:disabled {\n    opacity: 0.72;\n    cursor: wait;\n}\n\n.zashani-loader {\n    width: 46px;\n    height: 46px;\n    display: inline-grid;\n    place-items: center;\n    border-radius: 15px;\n    background: linear-gradient(145deg, rgba(7, 11, 26, 0.95), rgba(37, 50, 122, 0.92));\n    box-shadow: 0 16px 36px rgba(37, 50, 122, 0.2);\n    animation: zPulse 1200ms ease-in-out infinite;\n}\n\n.zashani-loader.small {\n    width: 22px;\n    height: 22px;\n    border-radius: 7px;\n    box-shadow: none;\n}\n\n.zashani-loader svg {\n    width: 72%;\n    height: 72%;\n    fill: none;\n    stroke: var(--champagne);\n    stroke-width: 11;\n    stroke-linecap: square;\n    stroke-linejoin: miter;\n    stroke-dasharray: 155;\n    stroke-dashoffset: 155;\n    filter: drop-shadow(0 0 8px rgba(216, 194, 154, 0.34));\n    animation: drawZ 1200ms ease-in-out infinite;\n}\n\n.zashani-loader.small svg {\n    stroke-width: 13;\n}\n\n.icon-button {\n    width: 44px;\n    color: var(--blue);\n    background: var(--blue-soft);\n}\n\n.icon-button.is-spinning svg {\n    animation: spin 720ms linear infinite;\n}\n\n.icon-button.danger {\n    color: #8d2f35;\n    background: #ffe9e6;\n}\n\n.main-panel {\n    min-width: 0;\n    padding: 28px;\n}\n\n.topbar {\n    position: sticky;\n    top: 0;\n    z-index: 5;\n    margin: -28px -28px 24px;\n    padding: 22px 28px;\n    background: rgba(247, 248, 252, 0.78);\n    border-bottom: 1px solid var(--line);\n    backdrop-filter: blur(18px);\n}\n\n.topbar,\n.section-heading,\n.table-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n}\n\n.section-heading,\n.table-toolbar {\n    margin-bottom: 20px;\n}\n\n.section-heading.compact {\n    margin-bottom: 4px;\n}\n\n.section-heading.compact > strong {\n    min-width: 138px;\n    padding: 10px 14px;\n    border-radius: 999px;\n    color: var(--blue);\n    text-align: center;\n    background: var(--blue-soft);\n}\n\n.topbar h1,\n.section-heading h2,\n.panel h2 {\n    margin: 0;\n}\n\n.topbar h1 {\n    font-size: clamp(24px, 3vw, 34px);\n}\n\n.eyebrow {\n    margin: 0 0 4px;\n    color: var(--champagne);\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.13em;\n    text-transform: uppercase;\n}\n\n.topbar .eyebrow,\n.panel .eyebrow,\n.section-heading .eyebrow {\n    color: var(--blue);\n}\n\n.user-pill {\n    display: grid;\n    grid-template-columns: 42px auto;\n    grid-template-rows: auto auto;\n    align-items: center;\n    column-gap: 10px;\n    color: var(--muted);\n    font-size: 13px;\n}\n\n.avatar {\n    grid-row: 1 / 3;\n    width: 42px;\n    height: 42px;\n    display: grid;\n    place-items: center;\n    border-radius: 50%;\n    color: #fff;\n    font-weight: 900;\n    background: linear-gradient(135deg, var(--blue), var(--rose));\n    box-shadow: var(--shadow-soft);\n}\n\n.user-pill strong {\n    color: var(--ink);\n}\n\n.content-section,\n.two-column,\n.sales-layout {\n    display: grid;\n    gap: 22px;\n}\n\n.two-column {\n    grid-template-columns: minmax(300px, 400px) minmax(0, 1fr);\n    align-items: start;\n}\n\n.sales-layout {\n    grid-template-columns: minmax(420px, 1.08fr) minmax(0, 0.92fr);\n    align-items: start;\n}\n\n.panel,\n.metric-card {\n    position: relative;\n    border: 1px solid rgba(255, 255, 255, 0.76);\n    border-radius: 18px;\n    background: var(--panel);\n    box-shadow: var(--shadow-soft);\n    backdrop-filter: blur(16px);\n}\n\n.panel::before,\n.metric-card::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), transparent 46%);\n}\n\n.panel > *,\n.metric-card > * {\n    position: relative;\n}\n\n.panel {\n    display: grid;\n    gap: 16px;\n    padding: 20px;\n}\n\n.panel.is-busy {\n    overflow: hidden;\n}\n\n.form-title-row,\n.row-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.form-title-row {\n    justify-content: space-between;\n}\n\n.row-actions {\n    flex-wrap: nowrap;\n}\n\n.edit-panel {\n    position: relative;\n    display: grid;\n    gap: 13px;\n    padding: 16px;\n    border: 1px solid rgba(37, 50, 122, 0.18);\n    border-radius: 16px;\n    background: rgba(233, 236, 255, 0.42);\n}\n\n.edit-panel h3 {\n    margin: 0;\n}\n\n.edit-panel.is-busy {\n    overflow: hidden;\n}\n\n.panel-loader {\n    position: absolute;\n    inset: 0;\n    z-index: 4;\n    display: grid;\n    place-items: center;\n    align-content: center;\n    gap: 12px;\n    color: var(--blue);\n    font-size: 13px;\n    font-weight: 900;\n    background: rgba(247, 248, 252, 0.74);\n    backdrop-filter: blur(8px);\n}\n\n.sale-form {\n    border-color: rgba(37, 50, 122, 0.16);\n}\n\n.sale-date-pill {\n    width: max-content;\n    display: inline-flex;\n    align-items: center;\n    margin-top: 8px;\n    padding: 7px 10px;\n    border: 1px solid rgba(37, 50, 122, 0.12);\n    border-radius: 999px;\n    color: var(--ink-soft);\n    background: rgba(233, 236, 255, 0.58);\n    font-size: 12px;\n    font-weight: 900;\n}\n\n.customer-picker {\n    grid-column: 1 / -1;\n    display: grid;\n    gap: 9px;\n    padding: 11px;\n    border: 1px solid rgba(37, 50, 122, 0.13);\n    border-radius: 16px;\n    background:\n        linear-gradient(135deg, rgba(233, 236, 255, 0.78), rgba(255, 255, 255, 0.72)),\n        rgba(247, 248, 252, 0.82);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72);\n}\n\n.customer-picker-header,\n.customer-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.customer-picker-header div {\n    display: grid;\n    gap: 2px;\n}\n\n.customer-picker-header span,\n.customer-picker-header small,\n.customer-pagination span,\n.selected-customer span,\n.selected-customer small,\n.customer-results span,\n.customer-results small,\n.customer-empty span {\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.customer-picker-header span {\n    color: var(--navy);\n    font-size: 13px;\n    font-weight: 900;\n}\n\n.customer-picker-header small,\n.customer-pagination span,\n.selected-customer small,\n.customer-results small,\n.customer-empty span {\n    color: var(--muted);\n}\n\n.customer-picker-header button {\n    min-height: 34px;\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 12px;\n    border: 1px solid rgba(37, 50, 122, 0.13);\n    border-radius: 999px;\n    color: var(--blue);\n    background: rgba(255, 255, 255, 0.72);\n    font-size: 12px;\n    font-weight: 900;\n}\n\n.customer-picker-header button.active {\n    color: #fff;\n    border-color: transparent;\n    background: linear-gradient(135deg, var(--blue), #111a4d);\n}\n\n.search-field {\n    position: relative;\n}\n\n.search-field svg {\n    position: absolute;\n    left: 13px;\n    bottom: 13px;\n    color: var(--muted);\n}\n\n.search-field input {\n    padding-left: 40px;\n}\n\n.selected-customer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 12px;\n    padding: 9px 11px;\n    border: 1px solid rgba(24, 128, 86, 0.22);\n    border-radius: 13px;\n    background: rgba(223, 247, 234, 0.72);\n}\n\n.selected-customer strong {\n    color: #174b37;\n}\n\n.selected-customer span {\n    color: var(--ink-soft);\n}\n\n.customer-picker-collapsed {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 7px 12px;\n    min-height: 48px;\n    padding: 10px 12px;\n    border: 1px dashed rgba(37, 50, 122, 0.2);\n    border-radius: 13px;\n    background: rgba(255, 255, 255, 0.62);\n    animation: fadeIn 180ms ease both;\n}\n\n.customer-picker-collapsed > div {\n    display: grid;\n    gap: 2px;\n}\n\n.customer-picker-collapsed strong {\n    color: var(--navy);\n    font-size: 13px;\n}\n\n.customer-picker-collapsed span {\n    color: var(--muted);\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.customer-picker-collapsed .ghost-button {\n    min-height: 34px;\n    padding: 7px 10px;\n    border-radius: 999px;\n}\n\n.new-customer-fields {\n    display: grid;\n    gap: 13px;\n    padding: 14px;\n    border: 1px solid rgba(37, 50, 122, 0.12);\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.58);\n    animation: enterUp 220ms ease both;\n}\n\n.new-customer-fields h3 {\n    margin: 0;\n    color: var(--navy);\n    font-size: 16px;\n}\n\n.new-customer-fields .ghost-button {\n    min-height: 36px;\n}\n\n.customer-results {\n    display: grid;\n    gap: 6px;\n    max-height: 218px;\n    overflow: auto;\n    padding-right: 3px;\n}\n\n.customer-results .table-state {\n    min-height: 104px;\n}\n\n.customer-results button,\n.customer-empty {\n    display: grid;\n    grid-template-columns: minmax(0, 1.2fr) minmax(86px, 0.5fr);\n    gap: 4px 10px;\n    align-items: center;\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid rgba(31, 39, 71, 0.09);\n    border-radius: 12px;\n    text-align: left;\n    background: rgba(255, 255, 255, 0.8);\n    transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.customer-results button:hover,\n.customer-results button.active {\n    transform: translateY(-1px);\n    border-color: rgba(37, 50, 122, 0.22);\n    background: #fff;\n    box-shadow: 0 14px 28px rgba(17, 21, 34, 0.08);\n}\n\n.customer-results button.active {\n    border-color: rgba(24, 128, 86, 0.34);\n    box-shadow: 0 16px 30px rgba(24, 128, 86, 0.12);\n}\n\n.customer-results strong,\n.customer-empty strong {\n    min-width: 0;\n    overflow: hidden;\n    color: var(--navy);\n    font-size: 13px;\n    line-height: 1.2;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.customer-results span {\n    justify-self: end;\n    color: var(--ink-soft);\n}\n\n.customer-results small {\n    grid-column: 1 / -1;\n}\n\n.customer-empty {\n    grid-template-columns: 1fr;\n    min-height: 74px;\n    align-content: center;\n}\n\n.customer-pagination {\n    padding-top: 2px;\n}\n\n.customer-list-controls {\n    display: grid;\n    padding: 12px;\n    border: 1px solid var(--line);\n    border-radius: 16px;\n    background: rgba(247, 248, 252, 0.72);\n}\n\n.metric-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n    gap: 16px;\n}\n\n.metric-card {\n    display: grid;\n    gap: 8px;\n    min-height: 132px;\n    padding: 20px;\n    overflow: hidden;\n    animation: enterUp 520ms ease both;\n    animation-delay: var(--delay, 0ms);\n}\n\n.metric-card::after {\n    content: \"\";\n    position: absolute;\n    right: 18px;\n    bottom: 16px;\n    width: 64px;\n    height: 6px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, var(--champagne), var(--blue));\n    opacity: 0.5;\n}\n\n.metric-card span {\n    color: var(--muted);\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.metric-card strong {\n    color: var(--navy);\n    font-size: clamp(28px, 4vw, 38px);\n    line-height: 1;\n}\n\n.metric-skeleton span,\n.metric-skeleton strong {\n    display: block;\n    border-radius: 999px;\n    color: transparent;\n    background: linear-gradient(90deg, rgba(37, 50, 122, 0.08), rgba(216, 194, 154, 0.2), rgba(37, 50, 122, 0.08));\n    background-size: 220% 100%;\n    animation: shimmer 1100ms ease-in-out infinite;\n}\n\n.metric-skeleton span {\n    width: 56%;\n    height: 14px;\n}\n\n.metric-skeleton strong {\n    width: 74%;\n    height: 42px;\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 13px;\n}\n\n.form-grid.three {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.form-grid.four {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.line-items {\n    display: grid;\n    gap: 10px;\n}\n\n.line-item {\n    display: grid;\n    grid-template-columns: minmax(150px, 1fr) 140px 44px;\n    gap: 9px;\n    align-items: center;\n    padding: 10px;\n    border: 1px solid var(--line);\n    border-radius: 16px;\n    background: rgba(247, 248, 252, 0.78);\n}\n\n.product-image-uploader {\n    display: grid;\n    grid-template-columns: 92px minmax(0, 1fr) auto;\n    gap: 12px;\n    align-items: end;\n    padding: 12px;\n    border: 1px solid var(--line);\n    border-radius: 16px;\n    background: rgba(247, 248, 252, 0.76);\n}\n\n.product-image-preview,\n.product-thumb {\n    display: grid;\n    place-items: center;\n    overflow: hidden;\n    border: 1px solid rgba(31, 39, 71, 0.1);\n    color: var(--blue);\n    background:\n        linear-gradient(135deg, rgba(233, 236, 255, 0.82), rgba(251, 247, 239, 0.86));\n}\n\n.product-image-preview {\n    width: 92px;\n    aspect-ratio: 1;\n    border-radius: 16px;\n    font-size: 28px;\n}\n\n.product-thumb {\n    width: 52px;\n    aspect-ratio: 1;\n    border-radius: 12px;\n    font-size: 20px;\n}\n\n.product-thumb.has-image {\n    color: #6f541e;\n    background: linear-gradient(135deg, rgba(216, 194, 154, 0.45), rgba(233, 236, 255, 0.78));\n}\n\n.image-status {\n    width: max-content;\n    min-width: 118px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n    padding: 8px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 900;\n    white-space: nowrap;\n}\n\n.image-status svg {\n    width: 16px;\n    height: 16px;\n}\n\n.image-status.is-ready {\n    color: #176a3a;\n    border: 1px solid rgba(23, 106, 58, 0.18);\n    background: rgba(222, 247, 232, 0.9);\n}\n\n.image-status.is-missing {\n    color: #a53636;\n    border: 1px solid rgba(165, 54, 54, 0.18);\n    background: rgba(255, 232, 232, 0.92);\n}\n\n.product-image-preview img,\n.product-thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.toggle-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.switch-row {\n    min-height: 46px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border: 1px solid var(--line);\n    border-radius: 14px;\n    color: var(--ink-soft);\n    background: rgba(247, 248, 252, 0.76);\n}\n\n.switch-row.compact {\n    min-height: 38px;\n    padding: 7px 9px;\n}\n\n.switch-row input {\n    width: 18px;\n    min-height: 18px;\n    accent-color: var(--blue);\n}\n\n.muted-row {\n    opacity: 0.68;\n}\n\n.inventory-heading {\n    margin-bottom: 0;\n}\n\n.inventory-insights {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(118px, 1fr));\n    gap: 10px;\n}\n\n.inventory-stat {\n    position: relative;\n    display: grid;\n    gap: 5px;\n    min-height: 82px;\n    padding: 14px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.76);\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.76);\n    box-shadow: 0 12px 28px rgba(17, 21, 34, 0.06);\n}\n\n.inventory-stat::after {\n    content: \"\";\n    position: absolute;\n    right: 12px;\n    bottom: 12px;\n    width: 44px;\n    height: 5px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, var(--champagne), var(--blue));\n    opacity: 0.42;\n}\n\n.inventory-stat span {\n    color: var(--muted);\n    font-size: 11px;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.inventory-stat strong {\n    color: var(--navy);\n    font-size: 28px;\n    line-height: 1;\n}\n\n.inventory-stat.success strong {\n    color: #176a3a;\n}\n\n.inventory-stat.danger strong {\n    color: #a53636;\n}\n\n.inventory-stat.warning strong {\n    color: #8a681f;\n}\n\n.inventory-page .panel {\n    padding: 16px;\n}\n\n.inventory-page .table-toolbar {\n    display: grid;\n    grid-template-columns: minmax(280px, 1fr) auto;\n    align-items: start;\n    gap: 12px;\n}\n\n.inventory-control-bar {\n    display: grid;\n    grid-template-columns: minmax(220px, 1fr) auto auto;\n    gap: 9px;\n    align-items: center;\n}\n\n.search-control {\n    min-height: 44px;\n    display: grid;\n    grid-template-columns: 20px minmax(0, 1fr);\n    gap: 8px;\n    align-items: center;\n    padding: 0 12px;\n    border: 1px solid var(--line);\n    border-radius: 13px;\n    color: var(--muted);\n    background: rgba(247, 248, 252, 0.9);\n}\n\n.search-control input {\n    min-height: 40px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n}\n\n.inventory-filter-chips {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.inventory-filter-chips button {\n    min-height: 38px;\n    padding: 8px 11px;\n    border: 1px solid rgba(31, 39, 71, 0.09);\n    border-radius: 999px;\n    color: var(--ink-soft);\n    font-size: 12px;\n    font-weight: 900;\n    background: rgba(247, 248, 252, 0.92);\n}\n\n.inventory-filter-chips button.active {\n    color: #fff;\n    border-color: transparent;\n    background: linear-gradient(135deg, var(--blue), #111a4d);\n    box-shadow: 0 12px 24px rgba(37, 50, 122, 0.18);\n}\n\n.inventory-filter-chips button.muted {\n    color: var(--muted);\n    background: rgba(112, 121, 148, 0.12);\n}\n\n.inventory-page .table-wrap {\n    max-height: calc(100vh - 360px);\n    min-height: 430px;\n    border-radius: 14px;\n}\n\n.inventory-page th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: rgba(247, 248, 252, 0.96);\n    backdrop-filter: blur(10px);\n}\n\n.inventory-page td {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.pagination-bar {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    align-items: center;\n    margin-top: 14px;\n    color: var(--muted);\n    font-size: 13px;\n    font-weight: 900;\n}\n\n.catalog-product-cell {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 220px;\n}\n\n.icon-button.is-featured {\n    color: #6f541e;\n    background: rgba(216, 194, 154, 0.32);\n}\n\n.public-catalog-page {\n    min-height: 100vh;\n    padding-top: 24px;\n    color: var(--ink);\n    background:\n        linear-gradient(180deg, rgba(7, 11, 26, 0.98) 0, rgba(17, 26, 77, 0.94) 460px, transparent 461px),\n        linear-gradient(135deg, rgba(216, 194, 154, 0.16), transparent 46%),\n        var(--paper);\n}\n\n.catalog-nav {\n    position: sticky;\n    top: 16px;\n    z-index: 20;\n    width: min(1180px, calc(100% - 32px));\n    min-height: 82px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 22px;\n    margin: 0 auto;\n    padding: 14px 18px;\n    border: 1px solid rgba(238, 241, 255, 0.14);\n    border-radius: 26px;\n    overflow: hidden;\n    background:\n        linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 40%),\n        rgba(7, 11, 26, 0.5);\n    box-shadow: 0 20px 55px rgba(7, 11, 26, 0.22);\n    backdrop-filter: blur(22px);\n    animation: catalogDropIn 520ms ease both;\n    transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease;\n}\n\n.catalog-nav::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background: linear-gradient(105deg, transparent 0, rgba(255, 255, 255, 0.11) 42%, transparent 68%);\n    transform: translateX(-110%);\n    animation: catalogShine 4.8s ease-in-out 900ms infinite;\n}\n\n.catalog-nav:hover {\n    transform: translateY(-1px);\n    border-color: rgba(216, 194, 154, 0.32);\n    box-shadow: 0 26px 65px rgba(7, 11, 26, 0.28);\n}\n\n.catalog-nav-brand {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    min-width: 0;\n}\n\n.catalog-nav-brand img {\n    width: min(176px, 48vw);\n    filter:\n        brightness(1.28)\n        saturate(1.18)\n        drop-shadow(0 0 14px rgba(82, 98, 216, 0.46))\n        drop-shadow(0 10px 20px rgba(0, 0, 0, 0.22));\n    transition: filter 220ms ease, transform 220ms ease;\n}\n\n.catalog-nav:hover .catalog-nav-brand img {\n    filter:\n        brightness(1.48)\n        saturate(1.24)\n        drop-shadow(0 0 18px rgba(112, 129, 255, 0.58))\n        drop-shadow(0 12px 24px rgba(0, 0, 0, 0.24));\n    transform: translateY(-1px);\n}\n\n.catalog-nav-brand span {\n    min-height: 34px;\n    display: inline-flex;\n    align-items: center;\n    padding-left: 18px;\n    border-left: 1px solid rgba(238, 241, 255, 0.16);\n    color: rgba(238, 241, 255, 0.74);\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.13em;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.catalog-nav-links {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px;\n    border: 1px solid rgba(238, 241, 255, 0.12);\n    border-radius: 999px;\n    background: rgba(7, 11, 26, 0.46);\n    backdrop-filter: blur(18px);\n}\n\n.catalog-nav-links a {\n    min-height: 36px;\n    display: inline-flex;\n    align-items: center;\n    padding: 0 14px;\n    border-radius: 999px;\n    color: rgba(238, 241, 255, 0.8);\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 900;\n}\n\n.catalog-nav-links a:hover {\n    color: #fff;\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.catalog-hero {\n    position: relative;\n    isolation: isolate;\n    min-height: 660px;\n    display: grid;\n    grid-template-columns: minmax(0, 0.9fr) minmax(340px, 1.1fr);\n    gap: clamp(22px, 5vw, 72px);\n    align-items: center;\n    width: min(1180px, calc(100% - 32px));\n    margin: 28px auto 38px;\n    padding: clamp(38px, 6vw, 72px);\n    overflow: hidden;\n    border: 1px solid rgba(238, 241, 255, 0.12);\n    border-radius: 34px;\n    box-shadow: 0 30px 90px rgba(7, 11, 26, 0.28);\n    color: #fff;\n    background-image:\n        linear-gradient(90deg, rgba(7, 11, 26, 0.98), rgba(7, 11, 26, 0.74) 48%, rgba(7, 11, 26, 0.08)),\n        var(--hero-image, linear-gradient(135deg, #070b1a, #25327a));\n    background-position: center;\n    background-size: cover;\n    animation: catalogHeroIn 660ms ease 80ms both;\n}\n\n.catalog-hero::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background:\n        linear-gradient(135deg, rgba(216, 194, 154, 0.16), transparent 32%),\n        linear-gradient(0deg, rgba(7, 11, 26, 0.28), transparent 34%);\n}\n\n.catalog-hero::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, rgba(216, 194, 154, 0.68), transparent);\n    animation: catalogGlowLine 3.8s ease-in-out infinite;\n}\n\n.catalog-hero-copy {\n    position: relative;\n    z-index: 1;\n    display: grid;\n    gap: 18px;\n    max-width: 620px;\n    animation: catalogHeroCopyIn 680ms ease both;\n}\n\n.catalog-hero-copy .eyebrow {\n    margin: 0;\n}\n\n.catalog-hero h1 {\n    margin: 0;\n    font-size: clamp(54px, 9vw, 118px);\n    line-height: 0.86;\n    letter-spacing: 0;\n    text-wrap: balance;\n    text-shadow: 0 22px 44px rgba(0, 0, 0, 0.32);\n}\n\n.catalog-hero-copy > p:last-of-type {\n    margin: 0;\n    max-width: 520px;\n    color: rgba(238, 241, 255, 0.82);\n    font-size: clamp(17px, 2vw, 21px);\n    font-weight: 700;\n    line-height: 1.5;\n}\n\n.catalog-hero-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 11px;\n    margin-top: 2px;\n}\n\n.catalog-hero-actions .primary-button,\n.catalog-hero-actions .ghost-button {\n    position: relative;\n    min-height: 50px;\n    overflow: hidden;\n    border-radius: 999px;\n}\n\n.catalog-hero-actions .primary-button::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.22), transparent);\n    transform: translateX(-120%);\n    animation: catalogShine 3.9s ease-in-out 1.1s infinite;\n}\n\n.catalog-whatsapp {\n    color: #fff;\n    border: 1px solid rgba(238, 241, 255, 0.16);\n    background: rgba(238, 241, 255, 0.12);\n    backdrop-filter: blur(14px);\n}\n\n.catalog-hero-stats {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 12px;\n    max-width: 560px;\n    margin-top: 4px;\n}\n\n.catalog-hero-stats span {\n    display: grid;\n    gap: 4px;\n    min-height: 72px;\n    padding: 13px 14px;\n    border: 1px solid rgba(238, 241, 255, 0.14);\n    border-radius: 18px;\n    color: rgba(238, 241, 255, 0.72);\n    background: rgba(238, 241, 255, 0.09);\n    backdrop-filter: blur(14px);\n    font-size: 11px;\n    font-weight: 900;\n    text-transform: uppercase;\n    transition: transform 180ms ease, background 180ms ease, border-color 180ms ease;\n}\n\n.catalog-hero-stats span:hover {\n    transform: translateY(-2px);\n    border-color: rgba(216, 194, 154, 0.28);\n    background: rgba(238, 241, 255, 0.13);\n}\n\n.catalog-hero-stats strong {\n    min-width: 0;\n    overflow: hidden;\n    color: #fff;\n    font-size: clamp(20px, 3vw, 30px);\n    line-height: 1;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.catalog-hero-showcase {\n    position: relative;\n    z-index: 1;\n    min-height: 460px;\n}\n\n.hero-product-shot {\n    position: absolute;\n    overflow: hidden;\n    border: 1px solid rgba(238, 241, 255, 0.16);\n    border-radius: 24px;\n    background: rgba(255, 255, 255, 0.1);\n    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);\n    transform-origin: center;\n    animation:\n        heroShotIn 680ms ease both,\n        heroFloat 6.8s ease-in-out infinite;\n    animation-delay: var(--shot-delay, 0ms), calc(760ms + var(--float-delay, 0ms));\n    will-change: transform;\n}\n\n.hero-product-shot img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transform: scale(1.01);\n    transition: transform 420ms ease, filter 420ms ease;\n}\n\n.hero-product-shot:hover img {\n    filter: saturate(1.08) contrast(1.04);\n    transform: scale(1.06);\n}\n\n.hero-product-shot span {\n    position: absolute;\n    left: 14px;\n    bottom: 14px;\n    padding: 7px 11px;\n    border-radius: 999px;\n    color: #fff;\n    background: rgba(7, 11, 26, 0.66);\n    backdrop-filter: blur(12px);\n    font-size: 12px;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.hero-product-shot.shot-1 {\n    inset: 16px 42px 42px 120px;\n}\n\n.hero-product-shot.shot-2 {\n    left: 12px;\n    bottom: 8px;\n    width: 210px;\n    height: 250px;\n    animation-delay: 90ms;\n}\n\n.hero-product-shot.shot-3 {\n    right: 4px;\n    top: 72px;\n    width: 178px;\n    height: 214px;\n    animation-delay: 160ms;\n}\n\n.empty-shot {\n    inset: 54px 80px;\n    display: grid;\n    place-items: center;\n    color: rgba(238, 241, 255, 0.76);\n    font-size: 44px;\n}\n\n.catalog-bar,\n.catalog-section,\n.catalog-notice {\n    width: min(1180px, calc(100% - 32px));\n    margin: 0 auto 22px;\n}\n\n.catalog-bar {\n    position: sticky;\n    top: 100px;\n    z-index: 12;\n    display: grid;\n    gap: 12px;\n    padding: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.78);\n    border-radius: 22px;\n    background: rgba(255, 255, 255, 0.84);\n    box-shadow: 0 20px 45px rgba(17, 21, 34, 0.1);\n    backdrop-filter: blur(18px);\n    animation: catalogLiftIn 600ms ease 120ms both;\n}\n\n.catalog-filter {\n    display: grid;\n    grid-template-columns: 180px minmax(220px, 1fr) auto;\n    gap: 10px;\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n    box-shadow: none;\n}\n\n.catalog-filter-label {\n    display: grid;\n    align-content: center;\n    padding: 8px 12px;\n    border-radius: 14px;\n    color: var(--navy);\n    background: rgba(233, 236, 255, 0.64);\n}\n\n.catalog-filter-label span {\n    font-size: 13px;\n    font-weight: 900;\n}\n\n.catalog-filter-label small {\n    color: var(--muted);\n    font-size: 11px;\n    font-weight: 800;\n}\n\n.catalog-filter label {\n    position: relative;\n}\n\n.catalog-filter label svg {\n    position: absolute;\n    left: 13px;\n    top: 50%;\n    z-index: 1;\n    transform: translateY(-50%);\n    color: var(--muted);\n}\n\n.catalog-filter input {\n    padding-left: 40px;\n    border-radius: 14px;\n    background: rgba(247, 248, 252, 0.92);\n}\n\n.catalog-category-strip {\n    display: flex;\n    gap: 9px;\n    overflow-x: auto;\n    padding: 2px 1px 5px;\n    scrollbar-width: thin;\n}\n\n.catalog-category-strip button {\n    flex: 0 0 auto;\n    min-height: 40px;\n    padding: 9px 14px;\n    border: 1px solid rgba(31, 39, 71, 0.1);\n    border-radius: 999px;\n    color: var(--ink-soft);\n    font-size: 13px;\n    font-weight: 900;\n    background: rgba(247, 248, 252, 0.92);\n}\n\n.catalog-category-strip button.active,\n.catalog-category-strip button:hover {\n    color: #fff;\n    border-color: transparent;\n    background: linear-gradient(135deg, rgba(37, 50, 122, 0.86), rgba(17, 26, 77, 0.94));\n    box-shadow: 0 14px 26px rgba(37, 50, 122, 0.18);\n}\n\n.catalog-notice {\n    border-radius: 16px;\n    padding: 13px 15px;\n    color: #174b37;\n    background: var(--success);\n    font-weight: 800;\n}\n\n.catalog-section {\n    display: grid;\n    gap: 18px;\n    padding: 8px 0 34px;\n    animation: catalogLiftIn 620ms ease 180ms both;\n}\n\n.catalog-section-title h2 {\n    margin: 4px 0 0;\n    font-size: clamp(24px, 4vw, 38px);\n}\n\n.catalog-section-title span {\n    display: inline-block;\n    margin-top: 5px;\n    color: var(--muted);\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.catalog-grid,\n.catalog-featured-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));\n    gap: 18px;\n}\n\n.catalog-featured-grid {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n\n.catalog-card {\n    position: relative;\n    display: grid;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.78);\n    border-radius: 22px;\n    background: rgba(255, 255, 255, 0.94);\n    box-shadow: 0 16px 42px rgba(17, 21, 34, 0.08);\n    animation: catalogCardIn 520ms ease var(--card-delay, 0ms) both;\n    transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;\n}\n\n.catalog-card:hover {\n    transform: translateY(-4px);\n    border-color: rgba(216, 194, 154, 0.42);\n    box-shadow: 0 26px 60px rgba(17, 21, 34, 0.14);\n}\n\n.catalog-card.featured {\n    display: grid;\n    grid-template-columns: 42% 1fr;\n    min-height: 270px;\n}\n\n.catalog-image {\n    position: relative;\n    min-height: 285px;\n    width: 100%;\n    display: grid;\n    place-items: center;\n    overflow: hidden;\n    border: 0;\n    border-radius: 0;\n    color: var(--blue);\n    font-size: 34px;\n    background:\n        linear-gradient(135deg, rgba(233, 236, 255, 0.88), rgba(251, 247, 239, 0.96));\n}\n\nbutton.catalog-image {\n    cursor: zoom-in;\n}\n\nbutton.catalog-image:disabled {\n    cursor: default;\n}\n\n.catalog-card.featured .catalog-image {\n    min-height: 100%;\n}\n\n.catalog-load-more {\n    display: flex;\n    justify-content: center;\n    padding: 8px 0 20px;\n}\n\n.is-spinning {\n    animation: spin 900ms linear infinite;\n}\n\n.catalog-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 220ms ease;\n}\n\nbutton.catalog-image:hover img {\n    transform: scale(1.04);\n}\n\n.catalog-zoom-hint {\n    position: absolute;\n    right: 12px;\n    bottom: 12px;\n    min-height: 34px;\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 7px 10px;\n    border-radius: 999px;\n    color: #fff;\n    background: rgba(7, 11, 26, 0.72);\n    backdrop-filter: blur(10px);\n    font-size: 12px;\n    font-weight: 900;\n    opacity: 0;\n    transform: translateY(6px);\n    transition: opacity 180ms ease, transform 180ms ease;\n}\n\nbutton.catalog-image:hover .catalog-zoom-hint,\nbutton.catalog-image:focus-visible .catalog-zoom-hint {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.catalog-card-body,\n.catalog-card.featured > div:last-child {\n    display: grid;\n    gap: 10px;\n    padding: 17px;\n}\n\n.catalog-card-topline {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n}\n\n.catalog-card span,\n.catalog-card small {\n    color: var(--muted);\n    font-size: 12px;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.catalog-card-topline small {\n    padding: 5px 8px;\n    border-radius: 999px;\n    color: #6f541e;\n    background: rgba(216, 194, 154, 0.24);\n}\n\n.catalog-code {\n    margin-top: -6px;\n}\n\n.catalog-card h3 {\n    margin: 0;\n    color: var(--navy);\n    font-size: 25px;\n    line-height: 1;\n    display: -webkit-box;\n    min-height: 50px;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n}\n\n.catalog-card p {\n    margin: 0;\n    color: var(--ink-soft);\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.45;\n    display: -webkit-box;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n}\n\n.catalog-card strong {\n    color: var(--ink);\n    font-size: 20px;\n}\n\n.catalog-card-footer {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    align-items: center;\n}\n\n.catalog-action {\n    min-height: 46px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 2px;\n    border-radius: 14px;\n    color: #fff;\n    background: linear-gradient(135deg, var(--blue), #111a4d);\n    text-decoration: none;\n    font-weight: 900;\n    box-shadow: 0 14px 28px rgba(37, 50, 122, 0.2);\n    transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.catalog-action:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 18px 34px rgba(37, 50, 122, 0.26);\n}\n\n.catalog-lightbox-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 100;\n    display: grid;\n    place-items: center;\n    padding: 22px;\n    background: rgba(7, 11, 26, 0.78);\n    backdrop-filter: blur(9px);\n    animation: fadeIn 180ms ease both;\n}\n\n.catalog-lightbox {\n    position: relative;\n    width: min(1120px, 100%);\n    max-height: 90vh;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 360px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 26px;\n    background: rgba(255, 255, 255, 0.96);\n    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.35);\n}\n\n.catalog-lightbox-image {\n    min-height: min(76vh, 740px);\n    display: grid;\n    place-items: center;\n    background:\n        radial-gradient(circle at 20% 20%, rgba(216, 194, 154, 0.22), transparent 32%),\n        #070b1a;\n}\n\n.catalog-lightbox-image img {\n    width: 100%;\n    height: 100%;\n    max-height: 86vh;\n    object-fit: contain;\n}\n\n.catalog-lightbox-info {\n    display: grid;\n    align-content: center;\n    gap: 14px;\n    padding: 34px;\n    background:\n        linear-gradient(135deg, rgba(233, 236, 255, 0.58), transparent 44%),\n        rgba(255, 255, 255, 0.96);\n}\n\n.catalog-lightbox-info span,\n.catalog-lightbox-info small {\n    color: var(--muted);\n    font-size: 12px;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.catalog-lightbox-info h2 {\n    margin: 0;\n    color: var(--navy);\n    font-size: 38px;\n    line-height: 0.96;\n}\n\n.catalog-lightbox-info p {\n    margin: 0;\n    color: var(--ink-soft);\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 1.5;\n}\n\n.catalog-lightbox-info strong {\n    color: var(--ink);\n    font-size: 30px;\n}\n\n.table-wrap {\n    overflow: auto;\n}\n\n.sale-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 80;\n    display: grid;\n    place-items: center;\n    padding: 22px;\n    background: rgba(17, 21, 34, 0.54);\n    backdrop-filter: blur(7px);\n    animation: fadeIn 180ms ease both;\n}\n\n.sale-breakdown {\n    position: relative;\n    display: grid;\n    gap: 16px;\n    padding: 18px;\n    border: 1px solid rgba(37, 50, 122, 0.12);\n    border-radius: 18px;\n    background:\n        linear-gradient(135deg, rgba(37, 50, 122, 0.08), transparent 38%),\n        linear-gradient(315deg, rgba(216, 194, 154, 0.2), transparent 40%),\n        rgba(255, 255, 255, 0.96);\n    box-shadow: 0 18px 40px rgba(17, 21, 34, 0.08);\n    animation: enterUp 220ms ease both;\n}\n\n.sale-modal {\n    width: min(980px, 100%);\n    max-height: min(86vh, 820px);\n    overflow: auto;\n}\n\n.product-edit-modal {\n    position: relative;\n    width: min(760px, 100%);\n}\n\n.product-edit-form {\n    padding-top: 28px;\n}\n\n.product-edit-form .form-title-row {\n    padding-right: 54px;\n}\n\n.modal-close-button {\n    position: absolute;\n    top: 14px;\n    right: 14px;\n    z-index: 2;\n    width: 40px;\n    min-height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(31, 39, 71, 0.1);\n    border-radius: 13px;\n    color: var(--navy);\n    background: rgba(255, 255, 255, 0.72);\n    box-shadow: 0 10px 24px rgba(17, 21, 34, 0.1);\n}\n\n.breakdown-header,\n.breakdown-title-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 14px;\n    align-items: flex-start;\n}\n\n.breakdown-header h3,\n.breakdown-section h4 {\n    margin: 0;\n}\n\n.breakdown-header h3 {\n    font-size: 20px;\n    line-height: 1.15;\n}\n\n.breakdown-header span,\n.breakdown-title-row span {\n    color: var(--muted);\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.breakdown-pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: flex-end;\n}\n\n.breakdown-pills span {\n    padding: 8px 10px;\n    border: 1px solid rgba(37, 50, 122, 0.12);\n    border-radius: 999px;\n    color: var(--blue);\n    background: rgba(233, 236, 255, 0.82);\n}\n\n.breakdown-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(190px, 1fr));\n    gap: 12px;\n}\n\n.breakdown-section {\n    padding: 14px;\n    border: 1px solid rgba(31, 39, 71, 0.1);\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.72);\n}\n\n.breakdown-section.wide {\n    display: grid;\n    gap: 12px;\n}\n\n.breakdown-section h4 {\n    color: var(--navy);\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n\n.breakdown-list {\n    display: grid;\n    gap: 10px;\n    margin: 12px 0 0;\n}\n\n.breakdown-list div {\n    display: flex;\n    justify-content: space-between;\n    gap: 14px;\n    border-bottom: 1px solid rgba(31, 39, 71, 0.08);\n    padding-bottom: 8px;\n}\n\n.breakdown-list div:last-child {\n    border-bottom: 0;\n    padding-bottom: 0;\n}\n\n.breakdown-list dt {\n    color: var(--muted);\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.breakdown-list dd {\n    margin: 0;\n    color: var(--ink);\n    font-size: 13px;\n    font-weight: 800;\n    text-align: right;\n}\n\n.items-breakdown {\n    display: grid;\n    gap: 8px;\n}\n\n.item-breakdown {\n    display: grid;\n    grid-template-columns: 1fr repeat(3, minmax(92px, auto));\n    gap: 10px;\n    align-items: center;\n    padding: 10px 12px;\n    border: 1px solid rgba(31, 39, 71, 0.09);\n    border-radius: 13px;\n    background: rgba(247, 248, 252, 0.74);\n}\n\n.item-breakdown strong {\n    color: var(--blue);\n    letter-spacing: 0.04em;\n}\n\n.item-breakdown span {\n    color: var(--ink-soft);\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.breakdown-total-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n    gap: 10px;\n}\n\n.breakdown-total-grid div {\n    display: grid;\n    gap: 5px;\n    padding: 13px;\n    border-radius: 15px;\n    color: var(--navy);\n    background: linear-gradient(135deg, rgba(233, 236, 255, 0.86), rgba(251, 247, 239, 0.92));\n}\n\n.breakdown-total-grid span {\n    color: var(--muted);\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.breakdown-total-grid strong {\n    font-size: 17px;\n}\n\n.breakdown-notes {\n    margin: 0;\n    color: var(--ink-soft);\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.5;\n}\n\n.table-subtitle {\n    display: inline-block;\n    margin-top: 4px;\n    color: var(--muted);\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.filter-panel {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 10px;\n    align-items: end;\n    padding: 12px;\n    border: 1px solid var(--line);\n    border-radius: 16px;\n    background: rgba(247, 248, 252, 0.72);\n}\n\n.filter-panel .search-field {\n    min-width: min(260px, 100%);\n}\n\n.report-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.report-filter {\n    align-self: start;\n}\n\n.location-report-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px;\n}\n\n.table-state {\n    min-height: 180px;\n    display: grid;\n    place-items: center;\n    align-content: center;\n    gap: 10px;\n    border: 1px dashed rgba(37, 50, 122, 0.2);\n    border-radius: 16px;\n    color: var(--muted);\n    font-size: 14px;\n    font-weight: 800;\n    background:\n        linear-gradient(135deg, rgba(255, 255, 255, 0.72), rgba(233, 236, 255, 0.58));\n}\n\n.table-state.is-loading {\n    color: var(--blue);\n}\n\n.alert,\n.notice {\n    border-radius: 14px;\n    padding: 11px 13px;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.alert {\n    color: #6d2420;\n    background: var(--danger);\n}\n\n.notice {\n    color: #174b37;\n    background: var(--success);\n}\n\n.danger-row td {\n    background: #fff1ed;\n}\n\n@keyframes enterUp {\n    from {\n        opacity: 0;\n        transform: translateY(14px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes gridDrift {\n    from {\n        transform: translate3d(0, 0, 0);\n    }\n    to {\n        transform: translate3d(78px, 78px, 0);\n    }\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes drawZ {\n    0% {\n        stroke-dashoffset: 155;\n        opacity: 0.62;\n    }\n    45%,\n    70% {\n        stroke-dashoffset: 0;\n        opacity: 1;\n    }\n    100% {\n        stroke-dashoffset: -155;\n        opacity: 0.7;\n    }\n}\n\n@keyframes zPulse {\n    0%,\n    100% {\n        transform: scale(0.96);\n    }\n    50% {\n        transform: scale(1.04);\n    }\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: 180% 0;\n    }\n    100% {\n        background-position: -40% 0;\n    }\n}\n\n@keyframes slideMenu {\n    from {\n        opacity: 0;\n        transform: translateX(-22px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes catalogDropIn {\n    from {\n        opacity: 0;\n        transform: translateY(-14px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes catalogHeroIn {\n    from {\n        opacity: 0;\n        transform: translateY(18px) scale(0.99);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes catalogHeroCopyIn {\n    from {\n        opacity: 0;\n        transform: translateY(18px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes catalogShine {\n    0%,\n    46% {\n        transform: translateX(-120%);\n    }\n    72%,\n    100% {\n        transform: translateX(120%);\n    }\n}\n\n@keyframes catalogGlowLine {\n    0%,\n    100% {\n        opacity: 0.44;\n        transform: scaleX(0.68);\n    }\n    50% {\n        opacity: 1;\n        transform: scaleX(1);\n    }\n}\n\n@keyframes catalogLiftIn {\n    from {\n        opacity: 0;\n        transform: translateY(16px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes catalogCardIn {\n    from {\n        opacity: 0;\n        transform: translateY(18px) scale(0.98);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes heroShotIn {\n    from {\n        opacity: 0;\n        transform: translateY(22px) scale(0.96);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes heroFloat {\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-12px);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        scroll-behavior: auto !important;\n        transition-duration: 0.01ms !important;\n    }\n}\n\n@media (max-width: 1080px) {\n    .app-shell,\n    .two-column,\n    .sales-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .catalog-hero {\n        grid-template-columns: 1fr;\n        min-height: auto;\n        gap: 34px;\n        padding: 52px 30px 44px;\n    }\n\n    .catalog-hero-showcase {\n        min-height: 360px;\n    }\n\n    .hero-product-shot.shot-1 {\n        inset: 0 80px 28px 80px;\n    }\n\n    .hero-product-shot.shot-2 {\n        left: 0;\n        bottom: 0;\n        width: 190px;\n        height: 220px;\n    }\n\n    .hero-product-shot.shot-3 {\n        right: 0;\n        top: 52px;\n        width: 160px;\n        height: 190px;\n    }\n\n    .catalog-bar {\n        position: static;\n        top: auto;\n    }\n\n    .inventory-insights {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    .inventory-page .table-toolbar {\n        grid-template-columns: 1fr;\n    }\n\n    .inventory-filter-chips {\n        justify-content: flex-start;\n    }\n\n    .sidebar {\n        position: static;\n        height: auto;\n        padding: 18px 20px;\n    }\n\n    .side-nav {\n        grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));\n    }\n\n    .logout-button {\n        margin-top: 0;\n    }\n\n    .topbar {\n        position: static;\n        margin: 0 0 20px;\n        border: 1px solid var(--line);\n        border-radius: 18px;\n    }\n}\n\n@media (max-width: 860px) {\n    .login-shell {\n        min-height: auto;\n        grid-template-columns: 1fr;\n    }\n\n    .login-brand {\n        min-height: 270px;\n    }\n\n    .login-brand img {\n        width: min(330px, 100%);\n    }\n}\n\n@media (max-width: 720px) {\n    .main-panel,\n    .login-panel,\n    .login-brand {\n        padding: 16px;\n    }\n\n    .sidebar {\n        position: sticky;\n        top: 0;\n        z-index: 20;\n        gap: 14px;\n        padding: 12px 14px 14px;\n        border-radius: 0 0 22px 22px;\n    }\n\n    .mobile-header {\n        display: grid;\n        grid-template-columns: 46px minmax(0, 1fr) auto;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .mobile-brand {\n        display: grid;\n        gap: 6px;\n        min-width: 0;\n    }\n\n    .mobile-brand span {\n        color: rgba(238, 241, 255, 0.72);\n        font-size: 11px;\n        font-weight: 900;\n        letter-spacing: 0.15em;\n        text-transform: uppercase;\n    }\n\n    .mobile-icon-button,\n    .mobile-logout-button {\n        min-height: 42px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        border: 0;\n        border-radius: 13px;\n        color: #eef1ff;\n        backdrop-filter: blur(10px);\n    }\n\n    .mobile-icon-button {\n        width: 46px;\n        background: transparent;\n        font-size: 22px;\n    }\n\n    .mobile-icon-button:hover {\n        background: rgba(255, 255, 255, 0.08);\n    }\n\n    .mobile-logout-button {\n        justify-self: end;\n        width: 42px;\n        padding: 0;\n        background: transparent;\n        font-size: 22px;\n    }\n\n    .brand-block {\n        display: none;\n    }\n\n    .side-nav,\n    .logout-button {\n        display: none;\n    }\n\n    .sidebar.is-open .side-nav {\n        position: fixed;\n        top: 88px;\n        left: 0;\n        z-index: 30;\n        width: min(78vw, 310px);\n        max-height: calc(100vh - 104px);\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 8px;\n        overflow: auto;\n        padding: 14px;\n        border-radius: 0 22px 22px 0;\n        background:\n            linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(29, 40, 95, 0.96)),\n            var(--navy-deep);\n        box-shadow: 22px 24px 50px rgba(7, 11, 26, 0.34);\n        animation: slideMenu 240ms ease both;\n    }\n\n    .sidebar.is-open .side-nav a {\n        min-height: 52px;\n        padding: 12px 14px;\n        border: 1px solid rgba(255, 255, 255, 0.08);\n        background: rgba(255, 255, 255, 0.07);\n    }\n\n    .topbar,\n    .section-heading,\n    .table-toolbar {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .report-actions {\n        width: 100%;\n        justify-content: stretch;\n    }\n\n    .report-actions .primary-button,\n    .report-actions .ghost-button {\n        flex: 1;\n    }\n\n    .user-pill {\n        justify-items: start;\n    }\n\n    .form-grid,\n    .form-grid.three,\n    .form-grid.four,\n    .line-item,\n    .product-image-uploader,\n    .toggle-grid,\n    .catalog-filter,\n    .filter-panel,\n    .location-report-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .pagination-bar {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .inventory-insights {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .inventory-control-bar {\n        grid-template-columns: 1fr;\n    }\n\n    .inventory-page .table-wrap {\n        max-height: none;\n        min-height: 320px;\n    }\n\n    .catalog-nav {\n        top: 8px;\n        width: min(100% - 24px, 1180px);\n        min-height: 68px;\n        padding: 12px 15px;\n        border-radius: 20px;\n    }\n\n    .catalog-nav-brand {\n        gap: 12px;\n    }\n\n    .catalog-nav-brand img {\n        width: min(152px, 48vw);\n    }\n\n    .catalog-nav-brand span {\n        display: none;\n    }\n\n    .catalog-nav-links {\n        display: none;\n    }\n\n    .catalog-hero {\n        width: min(100% - 24px, 1180px);\n        margin-top: 20px;\n        margin-bottom: 28px;\n        padding: 38px 20px 30px;\n        border-radius: 26px;\n        background-image:\n            linear-gradient(180deg, rgba(7, 11, 26, 0.98), rgba(7, 11, 26, 0.76) 62%, rgba(7, 11, 26, 0.18)),\n            var(--hero-image, linear-gradient(135deg, #070b1a, #25327a));\n    }\n\n    .catalog-hero-copy {\n        gap: 16px;\n    }\n\n    .catalog-hero h1 {\n        font-size: clamp(46px, 17vw, 72px);\n    }\n\n    .catalog-hero-copy > p:last-of-type {\n        font-size: 16px;\n    }\n\n    .catalog-hero-actions {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n\n    .catalog-hero-stats {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 8px;\n        margin-top: 2px;\n    }\n\n    .catalog-hero-stats span {\n        min-height: 64px;\n        padding: 10px 8px;\n        border-radius: 16px;\n        font-size: 9px;\n        text-align: center;\n        align-content: center;\n    }\n\n    .catalog-hero-stats strong {\n        font-size: clamp(17px, 5vw, 23px);\n    }\n\n    .catalog-hero-showcase {\n        min-height: 280px;\n    }\n\n    .hero-product-shot.shot-1 {\n        inset: 0 38px 28px 38px;\n    }\n\n    .hero-product-shot.shot-2 {\n        width: 128px;\n        height: 156px;\n    }\n\n    .hero-product-shot.shot-3 {\n        top: 34px;\n        width: 118px;\n        height: 148px;\n    }\n\n    .catalog-filter {\n        grid-template-columns: 1fr;\n    }\n\n    .catalog-filter .primary-button {\n        width: 100%;\n    }\n\n    .catalog-card.featured {\n        grid-template-columns: 1fr;\n    }\n\n    .catalog-image,\n    .catalog-card.featured .catalog-image {\n        min-height: 240px;\n    }\n\n    .catalog-zoom-hint {\n        opacity: 1;\n        transform: none;\n    }\n\n    .catalog-lightbox-backdrop {\n        align-items: end;\n        padding: 12px;\n    }\n\n    .catalog-lightbox {\n        max-height: 92vh;\n        grid-template-columns: 1fr;\n        overflow: auto;\n    }\n\n    .catalog-lightbox-image {\n        min-height: 52vh;\n    }\n\n    .catalog-lightbox-info {\n        padding: 18px;\n    }\n\n    .sale-modal-backdrop {\n        align-items: end;\n        padding: 12px;\n    }\n\n    .sale-breakdown {\n        padding: 14px;\n        border-radius: 15px;\n    }\n\n    .sale-modal {\n        max-height: 88vh;\n        width: 100%;\n    }\n\n    .breakdown-header,\n    .breakdown-title-row {\n        display: grid;\n        gap: 10px;\n    }\n\n    .breakdown-pills {\n        justify-content: flex-start;\n    }\n\n    .breakdown-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .breakdown-list div,\n    .item-breakdown,\n    .customer-results button {\n        grid-template-columns: 1fr;\n    }\n\n    .customer-results span {\n        justify-self: start;\n    }\n\n    .customer-picker-header,\n    .customer-pagination,\n    .customer-picker-collapsed {\n        align-items: stretch;\n    }\n\n    .customer-picker-collapsed .ghost-button {\n        width: 100%;\n    }\n\n    .breakdown-list div {\n        display: grid;\n        gap: 4px;\n    }\n\n    .breakdown-list dd {\n        text-align: left;\n    }\n\n    .line-item .icon-button {\n        width: 100%;\n    }\n\n    .brand-logo {\n        width: 148px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
